<template>
    <div class="editor-page"  style="height: calc(100vh - 150px);overflow-y: auto;">
        <div class="page-header">
            <div  class="header-actions"> 
                <!-- <Upload
                    ref="docxUpload"
                    class="header-upload-wrap"
                    :before-upload="handleDocxUpload"
                    :show-upload-list="false"
                    :action="''"
                    accept=".docx"
                >
                    <Tooltip content="导入DOCX" transfer>
                        <div class="icon-action icon-action--theme">
                        <i class="iconfont icon-wendang-docx_doc"></i>
                        </div>
                    </Tooltip>
                </Upload> -->
                <Tooltip content="AI合同生成" transfer>
                    <div class="icon-action" @click="openAiGenerateModal">
                        <!-- <i class="iconfont icon-shengchenghetong1"></i> -->
                        <!-- <i class="iconfont icon-shengchenghetong-copy"></i> -->
                        <i class="iconfont icon-hetong"></i>
                    </div>
                </Tooltip> 
                
                <!-- （服务端转 HTML） -->
                <!-- <Upload
                    ref="docxUploadBackend"
                    class="header-upload-wrap"
                    :headers="uploadHeaders"
                    :action="docxToHtmlUploadAction"
                    name="file"
                    :show-upload-list="false"
                    :before-upload="beforeDocxToHtmlUpload"
                    :on-success="onDocxToHtmlUploadSuccess"
                    :on-error="onDocxToHtmlUploadError"
                    :format="['docx']"
                    :on-format-error="onDocxToHtmlFormatError"
                    accept=".docx"
                >
                    <Tooltip content="导入DOCX" transfer>
                        <div class="icon-action icon-action--theme">
                        <i class="iconfont icon-wendang-docx_doc"></i>
                        </div>
                    </Tooltip>
                </Upload>  -->

                <Tooltip content="导出DOCX" transfer v-if="hasAiGeneratedContract">
                    <div class="icon-action" @click="exportToDocx">
                    <i class="iconfont icon-wendangdaochu1"></i>
                    </div>
                </Tooltip>
 

                <Tooltip v-if="showAiFeatures && hasAiCache&&hasAiGeneratedContract" content="AI模型切换" transfer>
                    <div class="icon-action" @click="openAiConfigModal()">
                    <i class="iconfont icon-zhinengbianzu"></i>
                    </div>
                </Tooltip>

                <Tooltip v-if="enableEditorPrint&&hasAiGeneratedContract" content="打印/PDF" transfer>
                    <div class="icon-action" @click="printDocument">
                        <i class="iconfont icon-dayinji_o"></i>
                    </div>
                </Tooltip>

                <Tooltip content="AI对话" transfer v-if="hasAiGeneratedContract">
                    <div class="icon-action" @click="goAiChat">
                        <i class="iconfont icon-duihua"></i>
                    </div>
                </Tooltip>

                <Tooltip v-if="enableAiContractReview&&hasAiGeneratedContract" content="AI合同审查" transfer>
                    <div class="icon-action" @click="goAiContractReview">
                        <i class="iconfont icon-jurassic_audit-something"></i>
                    </div>
                </Tooltip>

                <!-- <Tooltip content="AI合同生成" transfer>
                    <div class="icon-action" @click="openAiGenerateModal">
                        <i class="iconfont icon-shengchenghetong"></i>
                    </div>
                </Tooltip>  --> 
               
            </div>

            <div class="header-title-wrap" >
                <div class="header-title-main">
                    <span class="header-title">AI合同编辑器</span>
                    <Tooltip placement="bottom" >
                        <Icon type="ios-help-circle-outline" size='18' style="margin:0 10px;font-weight: bold;" class="icon-cla" />
                        <div slot="content" style="font-size:12px;white-space: normal;max-width:400px;">
                            <p style="word-break: break-all;word-wrap: break-word;width: 230px;">编辑文件内容后，文件排版将可能与当前显示版本略有不同(包括字
                                体、段落间距等)，最终以签署合同页面为准。</p>  
                        </div>
                    </Tooltip>
                </div>
                <span v-if="hasAiGeneratedContract && showUploadAction" class="header-upload-tip">
                    （当前模式需点击右侧保存按钮，才可进行下一步操作）
                </span>

            </div>

            <div class="header-back-wrap">
                <Tooltip v-if="hasAiGeneratedContract" :content="isEditMode ? '切换到预览' : '切换到编辑'" transfer>
                    <div class="icon-action icon-action--theme" @click="toggleEditMode">
                        <i :class="['iconfont', isEditMode ? 'icon-yulan-copy' : 'icon-bianji-copy']"></i>
                    </div>
                </Tooltip> 

                <!-- <Tooltip content="保存并上传" transfer>
                    <div class="icon-action" @click="uploadAndBack">
                        <i class="iconfont icon-baocunbingfanhui"></i>
                    </div>
                </Tooltip> -->
                <Tooltip v-if="hasAiGeneratedContract && showUploadAction" content="保存并上传" transfer>
                    <div class="icon-action" @click="saveAndBack">
                        <i class="iconfont icon-baocun-copy"></i>
                    </div>
                </Tooltip>

                
                <Tooltip v-if="hasAiGeneratedContract && showBackAction" content="保存并返回" transfer>
                    <div class="icon-action" @click="saveAndBack">
                        <i class="iconfont icon-baocunbingfanhui"></i>
                    </div>
                </Tooltip> 
                
                <Tooltip v-if="showBackAction" content="返回" transfer>
                    <div class="r_back icon-action" @click="goBack">
                        <i class="iconfont icon-fanhui"></i>
                    </div>
                </Tooltip>
            </div>
        </div>

        <div v-if="!hasAiGeneratedContract" class="editor-entry-guide">
            <div class="editor-entry-guide__card">
                <h3 class="editor-entry-guide__title">AI 智能起草合同</h3>
                <p class="editor-entry-guide__desc">只需输入合同类型和特殊要求，AI 即可为您自动起草并跳转至编辑器。</p>
                <Button type="primary" icon="ios-bulb" @click="openAiGenerateModal">
                    立即开始生成
                </Button>
            </div>
        </div>

        <div v-show="hasAiGeneratedContract" class="editor-container">
            <!-- 编辑模式：AiEditor 容器 -->
            <div v-show="isEditMode" class="editor-mode">
                <div ref="aiEditorEl" class="ai-editor-host">
                    <!-- AiEditor 自定义布局容器：必须使用 aie-container 包裹 -->
                    <div class="aie-container" style="background-color: #f3f4f6">
                        <div class="aie-header-panel">
                            <div class="aie-container-header" style="background: #fff;"></div>
                        </div>
                        <div class="aie-main">
                            <div v-if="showDocumentOutline" class="aie-directory-content">
                                <div class="aie-directory">
                                    <div class="aie-directory__head">
                                        <span class="aie-directory__head-mark" aria-hidden="true"></span>
                                        <h5>文档目录</h5>
                                    </div>
                                    <div id="outline" class="aie-outline-list">
                                        <div v-if="!outlineItems.length" class="outline-empty">暂无标题</div>
                                        <a
                                            v-for="item in outlineItems"
                                            :key="item.id"
                                            :class="[
                                                `aie-title${Math.min(6, Math.max(1, item.level || 1))}`,
                                                { active: outlineActiveId === item.id }
                                            ]"
                                            @click.prevent="jumpToOutline(item)"
                                            href="#"
                                            :title="item.text"
                                        >
                                            {{ item.text }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="aie-container-panel">
                                <div class="aie-container-main"></div>
                            </div>
                        </div>
                        <div class="aie-container-footer"></div>
                    </div>
                </div>
            </div>

            <!-- 预览模式：分页预览 -->
            <div v-show="!isEditMode" class="preview-mode">
                <div class="preview-toolbar">
                    <div class="preview-toolbar__left">
                        <!-- <span class="preview-toolbar__icon-wrap" aria-hidden="true">
                            <Icon type="ios-eye" size="22" />
                        </span> -->
                        <Tooltip content="预览合同" transfer>
                            <div class="icon-action" >
                                <i class="iconfont icon-yulan1 iconfont-size-28"></i>
                            </div>
                        </Tooltip>
                        <div class="preview-toolbar__titles">
                            <span class="preview-toolbar__title">预览合同</span>
                            <span class="preview-toolbar__hint">分页为近似排版，正式出稿请以签署合同页面为准</span>
                        </div>
                    </div>
                    <div class="preview-toolbar__right">
                        <Tooltip content="显示比例" transfer>
                            <div class="icon-action" @click="setPreviewZoom(85)">
                                <i class="iconfont icon-leixingbili"></i>
                            </div>
                        </Tooltip>
                        <ButtonGroup size="small" class="preview-zoom-btns" style="margin-right: 20px;">
                            <Button :type="previewZoom === 85 ? 'primary' : 'default'" @click="setPreviewZoom(85)">
                                85%
                            </Button>
                            <Button :type="previewZoom === 100 ? 'primary' : 'default'" @click="setPreviewZoom(100)">
                                100%
                            </Button>
                            <Button :type="previewZoom === 115 ? 'primary' : 'default'" @click="setPreviewZoom(115)">
                                115%
                            </Button>
                        </ButtonGroup>
                        <Tooltip content="回顶部" transfer>
                            <div class="icon-action" @click="scrollPreviewTop">
                                <i class="iconfont icon-huidingbu"></i>
                            </div>
                        </Tooltip>
                        <Tooltip content="去底部" transfer>
                            <div class="icon-action" @click="scrollPreviewBottom">
                                <i class="iconfont icon-qudibu"></i>
                            </div>
                        </Tooltip>
                        <!-- <Button size="small" class="preview-toolbar__action" @click="scrollPreviewTop">
                            回顶部
                        </Button> -->
                        <Tooltip content="刷新预览" transfer>
                            <div class="icon-action" @click="refreshPreviewPages">
                                <i class="iconfont icon-aishuaxin"></i>
                            </div>
                        </Tooltip>
                        <!-- <Button size="small" class="preview-toolbar__action" icon="md-refresh" @click="refreshPreviewPages">
                            刷新预览
                        </Button> -->
                    </div>
                </div>
                <div ref="previewScrollEl" class="preview-scroll">
                    <div
                        v-if="!pages.length"
                        class="preview-empty"
                    >
                        <div class="preview-empty__card">
                            <Icon type="ios-paper-outline" size="52" />
                            <p class="preview-empty__title">暂无可预览内容</p>
                            <p class="preview-empty__desc">切换到编辑模式输入正文，或导入 DOCX 后再预览</p>
                            <Button
                                type="primary"
                                icon="ios-create-outline"
                                @click="switchToEditMode"
                            >
                                去编辑
                            </Button>
                        </div>
                    </div>
                    <div
                        v-else
                        class="preview-zoom-root"
                        :style="previewZoomStyle"
                    >
                        <div class="pages-container">
                            <div
                                v-for="(page, index) in pages"
                                :key="index"
                                class="page"
                            >
                                <div class="page-number">第 {{ index + 1 }} 页</div>
                                <div class="page-body">
                                    <div class="page-content" v-html="page.content"></div>
                                </div>
                                <div class="page-sheet-footer">
                                    第 {{ index + 1 }} 页 / 共 {{ pages.length }} 页
                                </div>
                            </div>
                            <div class="page-counter">
                                <div class="counter-content">
                                    <Icon type="md-information-circle" />
                                    <span class="counter-text">
                                        版心约 {{ pageWidth }}×{{ pageHeight }}px · 左右边距 {{ pageMarginX }}px · 顶/底留白 {{ pageMarginTop }}px
                                    </span>
                                    <span class="divider">|</span>
                                    <span class="counter-text">共 {{ pages.length }} 页</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 右侧 AI 面板（对话 / 合同审查） -->
        <Drawer
            v-model="rightPanelVisible"
            placement="right"
            width="800"
            :closable="false"
            :mask-closable="true"
            class="ai-right-drawer"
        >
            <div class="ai-right-panel">
                <div class="ai-right-head">
                    <div class="ai-right-tabs">
                        <button
                            type="button"
                            :class="['ai-right-tab', rightPanelTab === 'chat' && 'is-active']"
                            @click="rightPanelTab = 'chat'"
                        >
                            AI对话
                        </button>
                        <button
                            v-if="enableAiContractReview"
                            type="button"
                            :class="['ai-right-tab', rightPanelTab === 'review' && 'is-active']"
                            @click="rightPanelTab = 'review'"
                        >
                            合同审查
                        </button>
                    </div>
                    <button
                        type="button"
                        class="ai-right-close"
                        aria-label="关闭"
                        @click="rightPanelVisible = false"
                    >
                        <Icon type="ios-close" size="22" />
                    </button>
                </div>

                <div class="ai-right-body">
                    <!-- AI 对话 -->
                    <div v-show="rightPanelTab === 'chat'" class="ai-chat-panel">
                        <div class="ai-chat-messages" ref="chatScrollEl">
                            <div
                                v-for="(item, index) in chatMessages"
                                :key="index"
                                :class="['ai-chat-message', item.role === 'user' ? 'ai-chat-message--user' : 'ai-chat-message--ai']"
                            >
                                <div class="ai-chat-message__role">
                                    {{ item.role === 'user' ? '我' : 'AI' }}
                                </div>
                                <div class="ai-chat-message__content">
                                    <pre>{{ item.content }}</pre>
                                </div>
                            </div>
                            <div
                                v-if="chatLoading"
                                class="ai-chat-message ai-chat-message--ai ai-chat-message--thinking"
                            >
                                <div class="ai-chat-message__role">AI</div>
                                <div class="ai-chat-message__content">
                                    <pre class="ai-chat-thinking">
                                        思考中
                                        <span class="ai-chat-dots" aria-hidden="true">
                                            <span class="ai-chat-dot"></span>
                                            <span class="ai-chat-dot"></span>
                                            <span class="ai-chat-dot"></span>
                                        </span>
                                    </pre>
                                </div>
                            </div>
                            <div v-if="!chatMessages.length && !chatLoading" class="ai-chat-empty">
                                请输入问题，与 AI 进行多轮对话。
                            </div>
                            <!-- 用于定位滚动到底部 -->
                            <div ref="chatBottomEl"></div>
                        </div>
                        <div class="ai-chat-input">
                            <Input
                                v-model="chatInput"
                                type="textarea"
                                :rows="3"
                                :autosize="false"
                                placeholder="请在此输入要咨询的问题，回车发送"
                                @on-enter="handleSendChat"
                            />
                            <div class="ai-chat-input__actions">
                                <span class="ai-chat-input__hint">
                                    模型：{{ chatModel }} ｜ 剩余积分：
                                    <span class="ai-chat-input__hint-num">{{ aiCurrentPoints }}</span>
                                </span>
                                <Button
                                    type="primary"
                                    size="small"
                                    :loading="chatLoading"
                                    @click="handleSendChat"
                                >
                                    发送
                                </Button>
                            </div>
                        </div>
                    </div>

                    <!-- 合同审查 -->
                    <div v-show="rightPanelTab === 'review'" class="ai-review-panel">
                        <div class="ai-review-toolbar">
                            <div class="ai-review-toolbar__buttons">
                                <Button
                                    type="primary"
                                    size="small"
                                    long
                                    class="ai-review-btn ai-review-btn--primary"
                                    icon="ios-search"
                                    :loading="reviewLoading"
                                    @click="handleContractReview('contract_text', 2)"
                                >
                                    审查当前合同（文本方式-详细）
                                </Button>
                                <Button
                                    type="default"
                                    size="small"
                                    long
                                    class="ai-review-btn ai-review-btn--secondary"
                                    icon="ios-search"
                                    :loading="reviewLoading"
                                    @click="handleContractReview('contract_text', 1)"
                                >
                                    审查当前合同（文本方式-精简）
                                </Button>
                                <!-- <Button
                                    type="default"
                                    size="small"
                                    long
                                    class="ai-review-btn ai-review-btn--secondary"
                                    icon="ios-cloud-upload-outline"
                                    :loading="reviewLoading"
                                    @click="handleContractReview('contract_file')"
                                >
                                    审查当前合同（文件方式）
                                </Button> -->
                            </div>
                            <span class="ai-review-toolbar__hint">
                                每次审查会在下方生成一条记录；报错信息也会以消息形式展示，方便排查。
                            </span>
                        </div>
                        <div ref="reviewScrollEl" class="ai-review-content">
                            <Spin :fix="false" :show="reviewLoading">
                                <div v-if="!reviewMessages.length && !reviewLoading" class="ai-review-empty">
                                    点击上方按钮，对当前合同进行智能审查。
                                </div>
                                <div v-else class="ai-review-messages">
                                    <div
                                        v-for="(item, idx) in reviewMessages"
                                        :key="idx"
                                        :class="[
                                            'ai-chat-message',
                                            item.role === 'error' ? 'ai-review-message--error' : 'ai-chat-message--ai'
                                        ]"
                                    >
                                        <div class="ai-chat-message__role">
                                            {{ item.role === 'error' ? '错误' : 'AI' }}
                                        </div>
                                        <div class="ai-chat-message__content">
                                            <pre>{{ item.content }}</pre>
                                        </div>
                                    </div>
                                </div>
                            </Spin>
                        </div>
                    </div>
                </div>
            </div>
        </Drawer>

        <!-- AI 合同生成 -->
        <Modal
            v-model="aiGenerateVisible"
            title="AI合同生成"
            width="720"
            :mask-closable="false"
            class-name="ai-generate-modal"
        >
            <div >
                <div class="ai-generate-body">
                    <Alert type="info" show-icon style="margin-bottom: 16px; font-size: 12px;">
                        生成后将<strong>覆盖当前编辑器中的合同内容</strong>。如需保留，请先备份。
                    </Alert>
                    <!-- <Alert type="info" show-icon style="margin-bottom: 24px;">
                        输入完合同类型后，点击<strong>右侧发送按钮</strong>，可智能生成合同表单。才可进行<strong>生成合同</strong>操作。
                    </Alert> -->
                    <Form :model="aiGenerateForm" :label-width="100"  >
                        <FormItem label="合同类型" required>
                            <div class="ai-generate-row" style="display: flex; align-items: center;">
                                <Input v-model="aiGenerateForm.contract_type" placeholder="例如：劳动合同、租赁合同" @on-enter="handleAiGenerateFieldsClick" />
                                <Tooltip content="生成合同表单" transfer style="margin-left: 10px;">
                                    <div
                                        style="margin-left: 10px;font-size:23px;"
                                        :class="[
                                            'icon-action',
                                            { 'icon-action--theme': !!String(aiGenerateForm.contract_type || '').trim() },
                                            { 'icon-action--disabled': !String(aiGenerateForm.contract_type || '').trim() },
                                            { 'icon-action--loading': aiContractFieldsLoading }
                                        ]"
                                        @click="String(aiGenerateForm.contract_type || '').trim() ? handleAiGenerateFieldsClick() : null"
                                    >
                                        <i class="iconfont icon-a-shangchuan2 iconfont-size-28"   size="28" v-if="!String(aiGenerateForm.contract_type || '').trim()"></i>
                                        <i class="iconfont icon-a-shangchuan2-copy iconfont-size-28"   size="28" v-else></i>
                                    </div>
                                </Tooltip>
                            </div>
                        </FormItem>

                        <FormItem v-if="aiContractFieldsVisible" label="合同表单">
                            <Spin :show="aiContractFieldsLoading">
                                <div v-if="!aiContractFields.length" style="color: #808695;">
                                    
                                    {{ aiContractFieldsLoading ? '加载中...' : '暂无可填写字段。' }}
                                </div>
                                <div v-else class="ai-fields-grid">
                                    <div v-for="(f, idx) in aiContractFields" :key="idx" class="ai-field-item">
                                        <div class="ai-field-row">
                                            <div class="ai-field-row__label">{{ f.label }}：</div>
                                            <div class="ai-field-row__control">
                                                <Input
                                                    v-if="!f.type || f.type === 'text'"
                                                    v-model="aiContractFieldValues[f.label]"
                                                    style="width: 200px;"
                                                    :placeholder="`请输入${f.label}`"
                                                />
                                                <InputNumber
                                                    v-else-if="f.type === 'number'"
                                                    v-model="aiContractFieldValues[f.label]"
                                                    style="width: 200px;"
                                                    :placeholder="`请输入${f.label}`"
                                                />
                                                <DatePicker
                                                    v-else-if="f.type === 'date'"
                                                    v-model="aiContractFieldValues[f.label]"
                                                    type="date"
                                                    style="width: 200px;"
                                                    :placeholder="`请选择${f.label}`"
                                                />
                                                <Input
                                                    v-else
                                                    v-model="aiContractFieldValues[f.label]"
                                                    style="width: 200px;"
                                                    :placeholder="`请输入${f.label}`"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Spin>
                        </FormItem>
                        <FormItem label="特殊约定">
                            <div v-if="!aiGenerateKeywordVisible" class="ai-keyword-toggle">
                                <Button type="dashed" icon="md-add" size="small" @click="aiGenerateKeywordVisible = true">
                                    添加
                                </Button>
                            </div>
                            <div v-else class="ai-keyword-body">
                                <Input
                                    v-model="aiGenerateForm.keyword"
                                    type="textarea"
                                    :autosize="{ minRows: 2, maxRows: 6 }"
                                    placeholder="例如：合同中需要补充的条款"
                                    
                                />
                                <!-- style="width: 520px;" -->
                                <!-- <Button type="text" icon="ios-close" @click="aiGenerateKeywordVisible = false" /> -->
                            </div>
                        
                        </FormItem>
                        

                        <!-- <FormItem label="甲方信息">
                            <div
                                v-for="(item, index) in aiGenerateForm.party_a"
                                :key="'party_a_' + index"
                                class="ai-generate-row"
                            >
                                <Input
                                    v-model="item.name"
                                    placeholder="字段名，如：企业名称"
                                    style="width: 35%; margin-right: 8px;"
                                />
                                <Input
                                    v-model="item.value"
                                    placeholder="字段值，如：安徽×××科技有限公司"
                                    style="width: 55%; margin-right: 8px;"
                                />
                                <Button type="text" icon="ios-trash" @click="removePartyItem('a', index)" />
                            </div>
                            <Button type="dashed" size="small" icon="md-add" @click="addPartyItem('a')">新增甲方字段</Button>
                        </FormItem>

                        <FormItem label="乙方信息">
                            <div
                                v-for="(item, index) in aiGenerateForm.party_b"
                                :key="'party_b_' + index"
                                class="ai-generate-row"
                            >
                                <Input
                                    v-model="item.name"
                                    placeholder="字段名，如：联系人"
                                    style="width: 35%; margin-right: 8px;"
                                />
                                <Input
                                    v-model="item.value"
                                    placeholder="字段值，如：王先生"
                                    style="width: 55%; margin-right: 8px;"
                                />
                                <Button type="text" icon="ios-trash" @click="removePartyItem('b', index)" />
                            </div>
                            <Button type="dashed" size="small" icon="md-add" @click="addPartyItem('b')">新增乙方字段</Button>
                        </FormItem>

                        <FormItem label="自定义条款">
                            <div
                                v-for="(item, index) in aiGenerateForm.terms"
                                :key="'terms_' + index"
                                class="ai-generate-row"
                            >
                                <Input
                                    v-model="item.name"
                                    placeholder="条款名，如：质量标准"
                                    style="width: 35%; margin-right: 8px;"
                                />
                                <Input
                                    v-model="item.value"
                                    type="textarea"
                                    :autosize="{ minRows: 1, maxRows: 3 }"
                                    placeholder="条款内容，如：国标GB/T..."
                                    style="width: 55%; margin-right: 8px;"
                                />
                                <Button type="text" icon="ios-trash" @click="removeTermItem(index)" />
                            </div>
                            <Button type="dashed" size="small" icon="md-add" @click="addTermItem">新增条款</Button>
                        </FormItem> -->
                    </Form>
                </div>
                <div class="ai-point-tip">
                    <span>预计消耗:</span>
                    <span class="ai-point-tip__num">{{ aiGenerateCostPoints }}</span>
                    <span>积分</span>
                    <span class="ai-point-tip__gap"></span>
                    <span>当前余额:</span>
                    <span class="ai-point-tip__num">{{ aiCurrentPoints }}</span>
                    <span>积分</span>
                    <a class="ai-point-tip__recharge" @click.prevent="goRecharge" 
                    v-if="(userInfo.uniacid_id != 6 && userInfo.role == 2) || userInfo.uniacid_id == 6">[去充值]</a>
                </div>
            </div>
            <div slot="footer">
                <Button @click="aiGenerateVisible = false" :disabled="aiGenerateSubmitting">取消</Button>
                <Button
                    type="primary"
                    @click="submitAiGenerate"
                    :loading="aiGenerateSubmitting"
                    :disabled="!aiContractFieldsReady || aiGenerateSubmitting"
                >
                    生成合同
                </Button>
            </div>
        </Modal>

        <!-- AI 本地密钥配置（参考 https://aieditor.com.cn/docs/zh/ai/base.html） -->
        <Modal
            v-if="showAiFeatures"
            v-model="aiModalVisible"
            title="配置 AI 模型（本地密钥）"
            width="620"
            :mask-closable="false"
            class-name="ai-config-modal"
        >
            <Alert type="warning" show-icon style="margin-bottom: 16px;">
                <p style="margin: 0; line-height: 1.6;">
                    当前填写的 API Key 等信息仅会<strong>缓存在本机浏览器</strong>，不会由本平台上传到云端。
                    使用各厂商 AI 所产生的<strong>费用需由您自行承担</strong>；请勿将电脑借给他人使用已保存密钥的浏览器。
                    <strong>本平台不承担任何责任。</strong>
                </p>
                <p style="margin: 8px 0 0; font-size: 12px;" v-show="false">
                    <a href="https://aieditor.com.cn/docs/zh/ai/base.html" target="_blank" rel="noopener noreferrer">AiEditor AI 基础配置说明</a>
                </p>
            </Alert>
            <Form :label-width="118" label-position="left">
                <FormItem label="模型提供方">
                    <RadioGroup v-model="aiForm.provider">
                        <Radio label="openai">OpenAI 兼容（含 GPT、国内转发等）</Radio>
                        <Radio label="spark">讯飞星火</Radio>
                    </RadioGroup>
                </FormItem>
                <template v-if="aiForm.provider === 'openai'">
                    <FormItem label="API Key" required>
                        <Input
                            v-model="aiForm.openaiKey"
                            type="password"
                            password
                            placeholder="sk-..."
                            autocomplete="off"
                        />
                    </FormItem>
                    <FormItem label="模型名称" required>
                        <Input v-model="aiForm.openaiModel" placeholder="例如 gpt-4o-mini" />
                    </FormItem>
                    <FormItem label="API 根地址">
                        <Input v-model="aiForm.openaiEndpoint" placeholder="默认 https://api.openai.com（自建/转发可改）" />
                    </FormItem>
                </template>
                <template v-else>
                    <FormItem label="AppId" required>
                        <Input v-model="aiForm.sparkAppId" autocomplete="off" />
                    </FormItem>
                    <FormItem label="API Secret" required>
                        <Input v-model="aiForm.sparkApiSecret" type="password" password autocomplete="off" />
                    </FormItem>
                    <FormItem label="API Key" required>
                        <Input v-model="aiForm.sparkApiKey" type="password" password autocomplete="off" />
                    </FormItem>
                    <FormItem label="版本">
                        <Select v-model="aiForm.sparkVersion" style="width: 200px;">
                            <Option value="v1.1">v1.1（Spark Lite）</Option>
                            <Option value="v2.1">v2.1（Spark V2.0）</Option>
                            <Option value="v3.1">v3.1（Spark Pro）</Option>
                            <Option value="v3.5">v3.5（Spark Max）</Option>
                            <Option value="v4.0">v4.0（Spark 4.0 Ultra）</Option>
                        </Select>
                    </FormItem>
                    <div class="spark-version-hint">
                        <p class="spark-version-hint__title">在 version 配置中，注意星火产品与版本的对应关系：</p>
                        <ul class="spark-version-hint__list">
                            <li>Spark Lite → v1.1</li>
                            <li>Spark V2.0 → v2.1</li>
                            <li>Spark Pro → v3.1（注意：pro-128k 产品暂不支持）</li>
                            <li>Spark Max → v3.5</li>
                            <li>Spark4.0 Ultra → v4.0</li>
                        </ul>
                    </div>
                </template>
            </Form>
            <div slot="footer">
                <Button @click="aiModalVisible = false">取消</Button>
                <Button type="warning" ghost @click="clearAiLocalConfig">清除本地配置</Button>
                <Button type="primary" @click="confirmAiConfig">保存并重新加载</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import { AiEditor } from 'aieditor'
import 'aieditor/dist/style.css'

import mammoth from 'mammoth'
import htmlDocx from 'html-docx-js/dist/html-docx.js'
import { saveAs } from 'file-saver'
import config from '@/config/index'
import { getCookies } from '@/utils/helper'
import { flowRequest } from '@/utils/flowrequest'
import request from '@/utils/request'
import { aiSendMultichat, aiGenerateContract, aiGetContractFields, aiGetUserPointsnum, aiContractUpHtmlToPdf, edittempupdate } from '@/api/interFace'

/** mammoth 额外样式映射：对齐 Word/WPS 常见内置样式名，便于标题/强调等落到语义标签 */
const DOCX_MAMMOTH_STYLE_MAP = [
    // 中文界面 Word / WPS
    "p[style-name='标题 1'] => h1:fresh",
    "p[style-name='标题 2'] => h2:fresh",
    "p[style-name='标题 3'] => h3:fresh",
    "p[style-name='标题 4'] => h4:fresh",
    "p[style-name='标题 5'] => h5:fresh",
    "p[style-name='标题 6'] => h6:fresh",
    "p[style-name='标题1'] => h1:fresh",
    "p[style-name='标题2'] => h2:fresh",
    "p[style-name='标题3'] => h3:fresh",
    // 英文界面
    "p[style-name='Heading 1'] => h1:fresh",
    "p[style-name='Heading 2'] => h2:fresh",
    "p[style-name='Heading 3'] => h3:fresh",
    "p[style-name='Heading 4'] => h4:fresh",
    "p[style-name='Heading 5'] => h5:fresh",
    "p[style-name='Heading 6'] => h6:fresh",
    "r[style-name='Strong'] => strong",
    "p[style-name='Quote'] => blockquote:fresh",
    "p[style-name='Block Text'] => blockquote:fresh",
    "p[style-name='Intense Quote'] => blockquote:fresh"
]

/** AiEditor 本地 AI 配置（仅浏览器 localStorage，见弹窗免责声明） */
const AI_LOCAL_STORAGE_KEY = 'contract_editor2_aieditor_ai_v1'
/** 保存配置后整页刷新，用 sessionStorage 恢复正文（避免丢失编辑内容） */
const AI_SESSION_RESTORE_HTML_KEY = 'contract_editor2_aieditor_restore_html_v1'

/** 与 aieditor 默认工具栏一致，但去除末尾「ai」（关闭 AI 时使用） */
const AIEDITOR_TOOLBAR_KEYS_WITHOUT_AI = [
    'undo', 'redo', 'brush', 'eraser', 'divider',
    'heading', 'font-family', 'font-size', 'divider',
    'bold', 'italic', 'underline', 'strike', 'link', 'code', 'subscript', 'superscript', 'hr', 'todo', 'emoji', 'divider',
    'highlight', 'font-color', 'divider',
    'align', 'line-height', 'divider',
    'bullet-list', 'ordered-list', 'indent-decrease', 'indent-increase', 'break', 'divider',
    'image', 'video', 'quote', 'container', 'code-block', 'table', 'divider',
    'source-code', 'printer', 'fullscreen'
]
// , 'attachment' // 附件

export default {
    name: 'Editor2Ai',
    props: {
        initialContent: {
            type: String,
            default: ''
        },
        onlyShowUploadAction: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            /** DOCX 服务端转 HTML：与 BasicInfoContent 营业执照上传一致，action 随 config.apiUrl 变化 */
            docxToHtmlUploadAction: config.apiUrl + '/adminapi/ai/contract/up_file_tohtml',
            uploadHeaders: { 'Authori-zation': getCookies('token') },

            /** 手动控制开关（不通过 props，改这里即可） */
            showAiFeatures: false,
            showDocumentOutline: false,
            /** AiEditor 工具栏里是否允许视频块/资源 */
            enableEditorVideo: false,
            /** 顶部按钮 + 工具栏 printer 是否可用 */
            enableEditorPrint: true,
            /** AI 合同审查（顶栏入口 + 右侧面板「合同审查」页签） */
            enableAiContractReview: false,

            aiEditor: null,
            isEditMode: true,
            wordCount: 0,
            pages: [],
            outlineItems: [],
            outlineActiveId: '',

            // 纸张：默认 800×1132（与 Word 版心类似：上页头留白 + 左右页边距）
            basePageWidth: 800,
            basePageHeight: 1132,
            pageWidth: 800,
            pageHeight: 1132,
            /** 顶部留白（页头区，新文档时标题不贴顶） */
            pageMarginTop: 56,
            /** 左右页边距（约 1.9cm @96dpi） */
            pageMarginX: 72,
            /** 底部留白 */
            pageMarginBottom: 56,

            aiModalVisible: false,
            aiForm: {
                provider: 'openai',
                openaiKey: '',
                openaiModel: 'gpt-4o-mini',
                openaiEndpoint: 'https://api.openai.com',
                sparkAppId: '',
                sparkApiKey: '',
                sparkApiSecret: '',
                sparkVersion: 'v3.5'
            },
            /** 配置保存后刷新页面前，用 sessionStorage 恢复的 HTML */
            sessionRestoredHtml: undefined,
            consoleErrorBackup: null,
            aiConsoleErrorHooked: false,
            /** 预览区显示比例（%），仅影响预览滚动区域 */
            previewZoom: 100,

            /** 右侧 AI 面板 */
            rightPanelVisible: false,
            rightPanelTab: 'chat',

            /** AI 对话 */
            chatModel: 'qwen',
            chatInput: '',
            chatLoading: false,
            chatConversationId: 0,
            chatMessages: [],

            /** 合同审查结果 */
            reviewLoading: false,
            reviewMessages: [],

            /** AI 合同生成（本地开发环境默认直进在线编辑器） */
            hasAiGeneratedContract: process.env.NODE_ENV !== 'production' || (typeof window !== 'undefined' && (
                window.location.hostname === 'localhost' ||
                window.location.hostname === '127.0.0.1' ||
                window.location.hostname === '::1' ||
                /^192\.168\./.test(window.location.hostname) ||
                /^10\./.test(window.location.hostname) ||
                /^172\.(1[6-9]|2\d|3[0-1])\./.test(window.location.hostname)
            )),

            aiGenerateCostPoints: 0,
            aiCurrentPoints: 0,
            aiGenerateVisible: false,
            aiGenerateSubmitting: false,
            aiGenerateKeywordVisible: false,
            aiGenerateForm: {
                contract_type: '',
                keyword: '',
                party_a: [],
                party_b: [],
                terms: []
            },

            /** AI 合同生成：动态字段表单 */
            aiContractFieldsLoading: false,
            aiContractFieldsVisible: false,
            aiContractFieldsReady: false,
            aiContractFieldsContractType: '',
            aiContractFields: [],
            aiContractFieldValues: {}
        }
    },
    watch: {
        'aiGenerateForm.contract_type'(v) {
            const ct = String(v || '').trim()
            // 合同类型变更后，必须重新点按钮拉取字段才允许生成
            if (!ct) {
                this.aiContractFieldsReady = false
                this.aiContractFieldsVisible = false
                this.aiContractFieldsContractType = ''
                this.aiContractFields = []
                this.aiContractFieldValues = {}
                return
            }
            if (this.aiContractFieldsContractType && this.aiContractFieldsContractType !== ct) {
                this.aiContractFieldsReady = false
                this.aiContractFieldsVisible = false
                this.aiContractFieldsContractType = ''
                this.aiContractFields = []
                this.aiContractFieldValues = {}
            }
        }
    },
    computed: {
        showUploadAction() {
            return this.onlyShowUploadAction
        },
        showBackAction() {
            return !this.onlyShowUploadAction
        },
        previewZoomStyle() {
            const z = this.previewZoom / 100
            return { zoom: z }
        },
        /** 单页正文区高度（用于分页测量） */
        contentHeight() {
            return this.pageHeight - this.pageMarginTop - this.pageMarginBottom
        },
        /** 是否已缓存过本地 AI 配置（用于显示「模型切换」） */
        hasAiCache() {
            return this.isAiCacheValid(this.readAiCache())
        },
        userInfo() {
            return this.$store.state.userInfo
        }
    },
    mounted() {
        const restored = sessionStorage.getItem(AI_SESSION_RESTORE_HTML_KEY)
        if (restored !== null) {
            this.sessionRestoredHtml = restored
            sessionStorage.removeItem(AI_SESSION_RESTORE_HTML_KEY)
        }
        if (this.showAiFeatures) {
            this.hookAiConsoleError()
        }
        this.initAiEditor()
    },
    beforeDestroy() {
        this.unhookAiConsoleError()
        if (this.aiEditor) {
            this.aiEditor.destroy()
            this.aiEditor = null
        }
    },
    methods: {
        /** 与 Word/WPS 导出 HTML 接近：导出 DOCX、打印、内联样式复用 */
        getContractDocumentCssForExport() {
            return `
                html, body { margin: 0; }
                body {
                    box-sizing: border-box;
                    padding: ${this.pageMarginTop}px ${this.pageMarginX}px ${this.pageMarginBottom}px ${this.pageMarginX}px;
                    font-family: "SimSun","宋体","NSimSun","新宋体",serif;
                    font-size: 12pt;
                    line-height: 1.75;
                    color: #000000;
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                }
                p {
                    margin: 0 0 6pt 0;
                    text-indent: 0em;
                    text-align: justify;
                    word-break: break-word;
                }
                p[style*="text-align:center"],
                p[style*="text-align: center"] {
                    text-indent: 0;
                }
                h1, h2, h3, h4, h5, h6 {
                    text-indent: 0;
                    font-family: "SimHei","黑体","Microsoft YaHei","微软雅黑",sans-serif;
                    color: #000000;
                }
                h1 { font-size: 22pt; font-weight: bold; text-align: center; margin: 12pt 0; }
                h2 { font-size: 16pt; font-weight: bold; margin: 12pt 0 6pt 0; }
                h3 { font-size: 15pt; font-weight: bold; margin: 10pt 0 6pt 0; }
                h4 { font-size: 14pt; font-weight: bold; margin: 8pt 0 4pt 0; }
                h5 { font-size: 12pt; font-weight: bold; margin: 8pt 0 4pt 0; }
                h6 { font-size: 12pt; font-weight: bold; margin: 6pt 0 4pt 0; }
                table {
                    border-collapse: collapse;
                    width: 100%;
                    table-layout: fixed;
                    margin: 6pt 0;
                }
                th, td {
                    border: 1px solid #000000;
                    padding: 4pt 6pt;
                    vertical-align: top;
                    font-size: 12pt;
                    line-height: 1.75;
                }
                th { font-weight: bold; text-align: center; background: #f3f3f3; }
                ul, ol { margin: 6pt 0; padding-left: 2em; text-align: left; }
                li { margin: 3pt 0; text-indent: 0; }
                blockquote {
                    margin: 6pt 0;
                    padding: 4pt 0 4pt 1em;
                    border-left: 3px solid #cccccc;
                    color: #333333;
                }
                u { text-underline-position: under; }
                img { max-width: 100%; height: auto; vertical-align: middle; }
                pre, code {
                    font-family: "Consolas","Courier New",monospace;
                    font-size: 10.5pt;
                    white-space: pre-wrap;
                    word-break: break-all;
                }
            `.trim()
        },

        /** 修正 mammoth 输出，便于富文本保留下划线、背景色等 */
        normalizeImportedDocxHtml(html) {
            if (!html) return ''
            try {
                const parser = new DOMParser()
                const doc = parser.parseFromString(html, 'text/html')
                const spans = Array.from(doc.querySelectorAll('span'))
                spans.forEach(span => {
                    const styleAttr = span.getAttribute('style') || ''
                    const styleLower = styleAttr.toLowerCase()
                    let backgroundColorValue = ''
                    // if (styleLower.includes('text-decoration') && styleLower.includes('underline')) {
                    //     const u = doc.createElement('u')
                    //     const cleanedStyle = styleAttr.replace(/text-decoration\s*:\s*underline;?/ig, '').trim()
                    //     if (cleanedStyle) u.setAttribute('style', cleanedStyle)
                    //     if (span.getAttribute('class')) u.setAttribute('class', span.getAttribute('class'))
                    //     u.innerHTML = span.innerHTML
                    //     span.replaceWith(u)
                    //     span = u
                    // }
                    if (styleLower.includes('background-color')) {
                        const match = /background-color\s*:\s*([^;]+);?/i.exec(styleAttr)
                        if (match && match[1]) backgroundColorValue = match[1].trim()
                    } else if (styleLower.includes('background')) {
                        const match = /background\s*:\s*([^;]+);?/i.exec(styleAttr)
                        if (match && match[1]) backgroundColorValue = match[1].trim()
                    }
                    if (backgroundColorValue) {
                        // 1) 外层 span 保留原字体/字号/颜色等
                        // 2) 内层 mark 仅承载高亮，避免 AiEditor 清洗掉其他样式
                        const wrapper = doc.createElement('span')
                        const cleanedStyle = styleAttr
                            .replace(/background-color\s*:\s*[^;]+;?/ig, '')
                            .replace(/background\s*:\s*[^;]+;?/ig, '')
                            .trim()
                        if (cleanedStyle) wrapper.setAttribute('style', cleanedStyle)
                        if (span.getAttribute('class')) wrapper.setAttribute('class', span.getAttribute('class'))
                        if (span.getAttribute('lang')) wrapper.setAttribute('lang', span.getAttribute('lang'))

                        const mark = doc.createElement('mark')
                        mark.style.backgroundColor = backgroundColorValue
                        mark.innerHTML = span.innerHTML

                        wrapper.appendChild(mark)
                        span.replaceWith(wrapper)
                    }
                })
                return doc.body.innerHTML
            } catch (err) {
                console.warn('normalizeImportedDocxHtml error:', err)
                return html
            }
        },

        /** 导出前把 mark 还原为 span，避免下游不识别 mark 语义标签 */
        restoreMarkToSpanForExport(html) {
            if (!html) return ''
            try {
                const parser = new DOMParser()
                const doc = parser.parseFromString(html, 'text/html')
                const marks = Array.from(doc.querySelectorAll('mark'))
                marks.forEach(mark => {
                    const bg = mark.style && mark.style.backgroundColor ? mark.style.backgroundColor : ''
                    const parent = mark.parentElement
                    // 形如: <span style="..."><mark style="background-color:...">文本</mark></span>
                    // 导出时合并回单个 span，恢复接近源 DOCX 的结构
                    if (parent && parent.tagName === 'SPAN' && parent.childNodes.length === 1) {
                        const parentStyle = parent.getAttribute('style') || ''
                        const merged = `${parentStyle}${parentStyle && bg ? '; ' : ''}${bg ? `background-color: ${bg};` : ''}`.trim()
                        if (merged) parent.setAttribute('style', merged)
                        else parent.removeAttribute('style')
                        parent.innerHTML = mark.innerHTML
                    } else {
                        const span = doc.createElement('span')
                        const styleAttr = mark.getAttribute('style') || ''
                        if (styleAttr) span.setAttribute('style', styleAttr)
                        if (mark.getAttribute('class')) span.setAttribute('class', mark.getAttribute('class'))
                        span.innerHTML = mark.innerHTML
                        mark.replaceWith(span)
                    }
                })
                return doc.body.innerHTML
            } catch (err) {
                console.warn('restoreMarkToSpanForExport error:', err)
                return html
            }
        },

        readAiCache() {
            try {
                const raw = localStorage.getItem(AI_LOCAL_STORAGE_KEY)
                if (!raw) return null
                return JSON.parse(raw)
            } catch (e) {
                return null
            }
        },

        isAiCacheValid(cache) {
            if (!cache || !cache.provider) return false
            if (cache.provider === 'openai') {
                const o = cache.openai
                return !!(o && String(o.apiKey || '').trim() && String(o.model || '').trim())
            }
            if (cache.provider === 'spark') {
                const s = cache.spark
                return !!(s && String(s.appId || '').trim() && String(s.apiKey || '').trim() && String(s.apiSecret || '').trim())
            }
            return false
        },

        /**
         * 生成 AiEditor options.ai（见官方文档）
         * @see https://aieditor.com.cn/docs/zh/ai/base.html
         */
        buildAiEditorAiOption() {
            const cache = this.readAiCache()
            if (!this.isAiCacheValid(cache)) return null
            const ai = {
                bubblePanelEnable: true,
                bubblePanelModel: 'auto',
                models: {}
            }
            if (cache.provider === 'openai') {
                const ep = (cache.openai.endpoint || 'https://api.openai.com').replace(/\/$/, '')
                ai.models.openai = {
                    apiKey: cache.openai.apiKey,
                    model: cache.openai.model,
                    endpoint: ep
                }
                return ai
            }
            if (cache.provider === 'spark') {
                ai.models.spark = {
                    appId: cache.spark.appId,
                    apiKey: cache.spark.apiKey,
                    apiSecret: cache.spark.apiSecret,
                    version: cache.spark.version || 'v3.5'
                }
                return ai
            }
            return null
        },

        hookAiConsoleError() {
            if (this.aiConsoleErrorHooked) return
            this.consoleErrorBackup = console.error.bind(console)
            this.aiConsoleErrorHooked = true
            console.error = (...args) => {
                try {
                    const text = args
                        .map(a => {
                            if (a == null) return ''
                            if (typeof a === 'string') return a
                            if (a instanceof Error) return a.message || String(a)
                            return String(a)
                        })
                        .join(' ')
                    if (/ai model config error|AI model name config error/i.test(text)) {
                        this.$nextTick(() => {
                            this.openAiConfigModal({ fromError: true })
                        })
                    } else if (/can not get selected text/i.test(text)) {
                        this.$nextTick(() => {
                            this.$Message.warning(
                                'AI 续写需要光标所在段落里已有文字（空行会取不到上下文）。请先在本段输入几个字，或把光标移到上一段末尾；也可输入 / 打开命令面板使用「AI 续写」。'
                            )
                        })
                    }
                } catch (e) { /* ignore */ }
                this.consoleErrorBackup(...args)
            }
        },

        unhookAiConsoleError() {
            if (this.aiConsoleErrorHooked && this.consoleErrorBackup) {
                console.error = this.consoleErrorBackup
                this.consoleErrorBackup = null
                this.aiConsoleErrorHooked = false
            }
        },

        syncAiFormFromCache() {
            const c = this.readAiCache()
            if (c && c.provider === 'spark') {
                this.aiForm.provider = 'spark'
                this.aiForm.sparkAppId = (c.spark && c.spark.appId) || ''
                this.aiForm.sparkApiKey = (c.spark && c.spark.apiKey) || ''
                this.aiForm.sparkApiSecret = (c.spark && c.spark.apiSecret) || ''
                this.aiForm.sparkVersion = (c.spark && c.spark.version) || 'v3.5'
            } else {
                this.aiForm.provider = 'openai'
                this.aiForm.openaiKey = (c && c.openai && c.openai.apiKey) || ''
                this.aiForm.openaiModel = (c && c.openai && c.openai.model) || 'gpt-4o-mini'
                this.aiForm.openaiEndpoint = (c && c.openai && c.openai.endpoint) || 'https://api.openai.com'
            }
        },

        openAiConfigModal(opts = {}) {
            if (!this.showAiFeatures) return
            this.syncAiFormFromCache()
            this.aiModalVisible = true
            if (opts.fromError) {
                this.$Message.warning('检测到 AI 未配置或配置无效，请在弹窗中选择模型并填写密钥')
            }
        },

        confirmAiConfig() {
            let payload
            if (this.aiForm.provider === 'openai') {
                const key = String(this.aiForm.openaiKey || '').trim()
                const model = String(this.aiForm.openaiModel || '').trim()
                if (!key || !model) {
                    this.$Message.error('请填写 OpenAI 兼容接口的 API Key 与模型名称')
                    return
                }
                let endpoint = String(this.aiForm.openaiEndpoint || '').trim() || 'https://api.openai.com'
                endpoint = endpoint.replace(/\/$/, '')
                payload = {
                    provider: 'openai',
                    openai: { apiKey: key, model, endpoint }
                }
            } else {
                const appId = String(this.aiForm.sparkAppId || '').trim()
                const ak = String(this.aiForm.sparkApiKey || '').trim()
                const sk = String(this.aiForm.sparkApiSecret || '').trim()
                if (!appId || !ak || !sk) {
                    this.$Message.error('请完整填写讯飞星火的 AppId、API Key、API Secret')
                    return
                }
                payload = {
                    provider: 'spark',
                    spark: {
                        appId,
                        apiKey: ak,
                        apiSecret: sk,
                        version: this.aiForm.sparkVersion || 'v3.5'
                    }
                }
            }
            try {
                localStorage.setItem(AI_LOCAL_STORAGE_KEY, JSON.stringify(payload))
            } catch (e) {
                this.$Message.error('本地存储失败，请检查浏览器是否禁止写入')
                return
            }
            try {
                const html = this.getHtml()
                sessionStorage.setItem(AI_SESSION_RESTORE_HTML_KEY, html)
            } catch (e) {
                console.warn('sessionStorage restore skip:', e)
            }
            this.aiModalVisible = false
            this.$Message.success('已保存到本机，页面将重新加载以应用 AI 配置')
            window.location.reload()
        },

        clearAiLocalConfig() {
            this.$Modal.confirm({
                title: '清除本地 AI 配置',
                content: '确定清除本机已保存的模型与密钥吗？清除后需重新配置才能使用 AI。',
                onOk: () => {
                    try {
                        const html = this.getHtml()
                        sessionStorage.setItem(AI_SESSION_RESTORE_HTML_KEY, html)
                    } catch (e) { /* ignore */ }
                    localStorage.removeItem(AI_LOCAL_STORAGE_KEY)
                    this.$Message.success('已清除，页面将重新加载')
                    window.location.reload()
                }
            })
        },

        initAiEditor() {
            const el = this.$refs.aiEditorEl
            if (!el) return

            const hasInitialContent = !!String(this.sessionRestoredHtml != null ? this.sessionRestoredHtml : this.initialContent || '').trim()
            const isLocalEnv = process.env.NODE_ENV !== 'production' || (typeof window !== 'undefined' && (
                window.location.hostname === 'localhost' ||
                window.location.hostname === '127.0.0.1' ||
                window.location.hostname === '::1' ||
                /^192\.168\./.test(window.location.hostname) ||
                /^10\./.test(window.location.hostname) ||
                /^172\.(1[6-9]|2\d|3[0-1])\./.test(window.location.hostname)
            )) 
            // isLocalEnv ||
            this.hasAiGeneratedContract =  hasInitialContent
            const defaultHtml = this.hasAiGeneratedContract ? '<p>开始编辑您的合同内容...</p>' : ''
            const content =
                this.sessionRestoredHtml !== undefined && this.sessionRestoredHtml !== null
                    ? this.sessionRestoredHtml
                    : (this.initialContent || defaultHtml)
            this.sessionRestoredHtml = undefined

            const options = {
                element: el,
                placeholder: '点击输入合同内容...',
                content,
                onCreated: editor => {
                    this.aiEditor = editor
                    this.refreshWordCount()
                    this.refreshOutline()
                },
                onChange: editor => {
                    this.aiEditor = editor
                    this.refreshWordCount()
                    this.refreshOutline()
                }
            }
            let toolbarKeys = [...AIEDITOR_TOOLBAR_KEYS_WITHOUT_AI]

            // video / printer 由变量管控
            if (!this.enableEditorVideo) {
                toolbarKeys = toolbarKeys.filter(k => k !== 'video')
            }
            if (!this.enableEditorPrint) {
                toolbarKeys = toolbarKeys.filter(k => k !== 'printer')
            }

            // AI：决定是否展示 ai 工具与 / 指令等
            if (this.showAiFeatures) {
                toolbarKeys.push('ai')
                const aiOption = this.buildAiEditorAiOption()
                if (aiOption) options.ai = aiOption
            } else {
                options.ai = {
                    commandsEnable: false,
                    bubblePanelEnable: false
                }
            }

            options.toolbarKeys = toolbarKeys
            this.aiEditor = new AiEditor(options)

            // 兜底：部分版本若未触发 onCreated/onChange，延迟刷新一次
            setTimeout(() => {
                if (!this.aiEditor) return
                this.refreshWordCount()
                this.refreshOutline()
            }, 300)
        },

        refreshWordCount() {
            if (!this.aiEditor) return
            const text = this.aiEditor.getText ? this.aiEditor.getText() : ''
            this.wordCount = (text || '').length
        },

        refreshOutline() {
            if (!this.showDocumentOutline) {
                this.outlineItems = []
                this.outlineActiveId = ''
                return
            }
            if (!this.aiEditor || !this.aiEditor.getOutline) {
                this.outlineItems = []
                this.outlineActiveId = ''
                return
            }
            try {
                const list = this.aiEditor.getOutline() || []
                this.outlineItems = Array.isArray(list) ? list : []
                if (!this.outlineActiveId && this.outlineItems.length) {
                    this.outlineActiveId = this.outlineItems[0].id || ''
                }
            } catch (e) {
                console.warn('[AiEditor] getOutline failed', e)
                this.outlineItems = []
            }
        },

        jumpToOutline(item) {
            if (!item || !this.aiEditor) return
            this.outlineActiveId = item.id || ''
            if (this.aiEditor.focusPos && typeof item.pos === 'number') {
                this.aiEditor.focusPos(item.pos)
            } else if (item.id) {
                const dom = document.getElementById(item.id)
                if (dom && dom.scrollIntoView) dom.scrollIntoView({ behavior: 'smooth', block: 'start' })
            }
        },

        getHtml() {
            if (!this.aiEditor) return ''
            return this.aiEditor.getHtml ? this.aiEditor.getHtml() : ''
        },

        setHtml(html) {
            if (!this.aiEditor) return
            // 官方 API 是 setContent，支持 HTML
            if (this.aiEditor.setContent) {
                this.aiEditor.setContent(html || '')
            }
        },

        toggleEditMode() {
            this.isEditMode = !this.isEditMode

            if (this.aiEditor && this.aiEditor.setEditable) {
                this.aiEditor.setEditable(this.isEditMode)
            }

            if (!this.isEditMode) {
                this.buildPages()
                this.$nextTick(() => this.scrollPreviewTop())
            }
        },

        switchToEditMode() {
            if (this.isEditMode) return
            this.isEditMode = true
            if (this.aiEditor && this.aiEditor.setEditable) {
                this.aiEditor.setEditable(true)
            }
        },

        setPreviewZoom(pct) {
            this.previewZoom = pct
        },

        scrollPreviewTop() {
            const el = this.$refs.previewScrollEl
            if (el) el.scrollTop = 0
        },
        scrollPreviewBottom() {
            const el = this.$refs.previewScrollEl
            if (el) el.scrollTop = el.scrollHeight
        },

        refreshPreviewPages() {
            if (this.isEditMode) return
            this.buildPages()
            if (this.pages.length) {
                this.$Message.success('预览已刷新')
            } else {
                this.$Message.info('当前正文为空，请先编辑或导入文档')
            }
        },

        goBack() {
            if(!this.hasAiGeneratedContract){
                this.$emit('back', { fromEditorDirectBack: true })
                return
            }else{
                this.$Modal.confirm({
                    title: '直接返回',
                    content: '直接返回不会更新当前文件解析结果（图片/PDF）。是否继续返回？',
                    onOk: () => {
                        // 直接返回：清空父组件 editor_html_content，再次进入富文本为空白/默认（与保存并返回、上传并返回区分）
                        this.$emit('back', { fromEditorDirectBack: true })
                    }
                })

            }
        },
        async uploadAndBack(){
            const rawHtml = this.getHtml()
            if (!String(rawHtml || '').trim()) {
                this.$Message.warning('正文为空，无法上传')
                return
            }
            try {
                const htmlContent = this.restoreMarkToSpanForExport(rawHtml)
                const fullHtml = `
                    <!DOCTYPE html>
                    <html>
                    <head>
                        <meta charset="utf-8">
                        <style>${this.getContractDocumentCssForExport()}</style>
                    </head>
                    <body>${htmlContent}</body>
                    </html>
                `
                const blob = htmlDocx.asBlob(fullHtml)
                await this.goUpload(blob)
            } catch (e) {
                console.error(e)
                this.$Message.error('DOCX 生成或上传失败')
            }
        },

        async saveAndBack() {
            const html = this.getHtml()
            if (!String(html || '').trim()) {
                this.$Message.warning('正文为空，无法保存并返回')
                return
            }
            const loading = this.$Message.loading({
                content: '保存并返回中，请稍候...',
                duration: 0
            })
            try {
                // const res = await aiContractUpHtmlToPdf({ html_content: html })
                // const res = await aiContractUpHtmlToPdf({ html_content: html })
                const htmlContent = this.restoreMarkToSpanForExport(html)
                const fullHtml = `<!DOCTYPE html>
                    <html>
                    <head>
                        <meta charset="utf-8">
                        <style>${this.getContractDocumentCssForExport()}</style>
                    </head>
                    <body>${htmlContent}</body>
                    </html>
                `
                const res = await aiContractUpHtmlToPdf({ html_content: fullHtml })
                if (!res || res.code !== 200 || !res.data) {
                    this.$Message.error((res && res.msg) || '保存并返回失败')
                    return
                }
                const payload = {
                    ...(res.data || {}),
                    html,
                    /** 供父组件识别：勿与接口里的 contract_content 等字段混淆，必须写入 editor_html_content */
                    fromEditorSaveAndBack: true
                }
                this.$emit('save', html)
                this.$emit('back', payload)
                this.$Message.success(res.msg || '保存并返回成功')
            } catch (e) {
                const msg = (e && (e.msg || e.message)) || '保存并返回失败'
                this.$Message.error(msg)
            } finally {
                setTimeout(loading, 100)
            }
        },

        triggerDocxSelect() {
            const upload = this.$refs.docxUpload
            if (!upload || !upload.$el) return
            const input = upload.$el.querySelector('input[type="file"]')
            if (input) input.click()
        },

        async handleDocxUpload(file) {
            try {
                const arrayBuffer = await file.arrayBuffer()
                const result = await mammoth.convertToHtml({
                    arrayBuffer,
                    styleMap: DOCX_MAMMOTH_STYLE_MAP,
                    includeDefaultStyleMap: true,
                    includeEmbeddedStyleMap: true
                })
                const normalizedHtml = this.normalizeImportedDocxHtml(result.value)
                this.setHtml(normalizedHtml)
                this.$nextTick(() => {
                    this.refreshWordCount()
                    this.refreshOutline()
                })
                this.$Message.success('DOCX 导入成功')
            } catch (e) {
                console.error(e)
                this.$Message.error('DOCX 导入失败')
            }
            return false
        },

        /** 从接口返回中取出 HTML（兼容 data 为字符串或 { html/content/data }） */
        pickHtmlFromUpFileToHtmlRes(res) {
            if (!res || res.data == null) return ''
            const d = res.data
            if (typeof d === 'string') return d
            if (d == null) return ''
            if (typeof d.html === 'string') return d.html
            if (typeof d.content === 'string') return d.content
            if (typeof d.data === 'string') return d.data
            return ''
        },

        beforeDocxToHtmlUpload(file) {
            const name = (file && file.name) || ''
            if (!/\.docx$/i.test(name)) {
                this.$Message.warning('请选择 .docx 文件')
                return false
            }
            return true
        },

        onDocxToHtmlUploadSuccess(res) {
            const e = res || {}
            if (e.code !== 200) {
                this.$Message.error(e.msg || 'DOCX 导入失败')
                return
            }
            const html = this.pickHtmlFromUpFileToHtmlRes(e)
            if (!html || !String(html).trim()) {
                this.$Message.error(e.msg || '服务端未返回可解析的 HTML')
                return
            }
            try {
                // this.normalizeImportedDocxHtml(html)
                // const normalizedHtml = html
                const normalizedHtml = this.normalizeImportedDocxHtml(html)
                this.setHtml(normalizedHtml)
                this.$nextTick(() => {
                    this.refreshWordCount()
                    this.refreshOutline()
                })
                this.$Message.success(e.msg || 'DOCX 导入成功')
            } catch (err) {
                console.error(err)
                this.$Message.error('DOCX 导入失败')
            }
        },

        onDocxToHtmlUploadError() {
            this.$Message.error('上传失败，请重试')
        },

        onDocxToHtmlFormatError() {
            this.$Message.warning('仅支持上传 .docx 文件')
        },

        async exportToDocx() {
            try {
                const htmlContent = this.restoreMarkToSpanForExport(this.getHtml())
                const fullHtml = `
                    <!DOCTYPE html>
                    <html>
                    <head>
                        <meta charset="utf-8">
                        <style>${this.getContractDocumentCssForExport()}</style>
                    </head>
                    <body>${htmlContent}</body>
                    </html>
                `
                const blob = htmlDocx.asBlob(fullHtml) 
                saveAs(blob, '合同文档.docx')
                this.$Message.success('DOCX 导出成功')
            } catch (e) {
                console.error(e)
                this.$Message.error('DOCX 导出失败')
            }
        },
       
        /** 与 ordinary.vue 选择文件上传一致：common/uploads（type:1）→ edittempupdate → 通知父级并返回 */
        async goUpload(blob) {
            if (!blob) {
                this.$Message.error('没有可上传的文件')
                return
            }
            const loadingMsg = this.$Message.loading({
                content: '文件上传中，请等待...',
                duration: 0
            })
            try {
                const fd = new FormData()
                fd.append('file', blob, '合同文档.docx')
                fd.append('type', 1)
                const uploadRes = await request({
                    url: 'common/uploads',
                    method: 'post',
                    data: fd
                })
                const e = uploadRes
                if (!e || e.code !== 200 || !e.data || !e.data.src) {
                    this.$Message.error((e && e.msg) || '上传失败')
                    return
                }
                const updateRes = await edittempupdate({ path: e.data.src })
                if (!updateRes || updateRes.code !== 200 || !updateRes.data) {
                    this.$Message.error((updateRes && updateRes.msg) || '解析合同失败')
                    return
                }
                const d = { ...updateRes.data, html: this.getHtml() }
                const payload = {
                    html: d.html,
                    document_type: d.document_type,
                    upload_type: d.upload_type,
                    imgs: d.imgs,
                    parse_file_id: d.parse_file_id,
                    path: d.path,
                    source_file_id: d.source_file_id || e.data.source_file_id || '',
                    contract_content: e.data.src
                }
                this.$emit('save', d.html)
                this.$emit('back', payload)
                this.$Message.success(e.msg || '上传成功')
            } catch (err) {
                this.$Message.error((err && err.msg) || (err && err.message) || '上传失败')
            } finally {
                setTimeout(loadingMsg, 100)
            }
        },

        goAiChat(){
            this.rightPanelVisible = true
            this.rightPanelTab = 'chat'
            this.fetchAiUserPoints()
        },

        goAiContractReview(){
            if (!this.enableAiContractReview) return
            this.rightPanelVisible = true
            this.rightPanelTab = 'review'
            this.fetchAiUserPoints()
        },

        openAiGenerateModal() {
            // keyword:
            //         '合同字体：宋体（或仿宋）\n' +
            //         '字号：小四（12pt）\n' +
            //         '行距：1.5 倍行距\n' +
            //         '段前段后：0\n' +
            //         '段落：首行缩进 2 字符，正文两端对齐\n' +
            //         '整体：更正式、规范，版式更美观（标题加粗、条款编号清晰）',

            // 劳动合同
            this.aiGenerateForm = {
                contract_type: '',
                keyword:'',
                party_a: [{ name: '', value: '' }],
                party_b: [{ name: '', value: '' }],
                terms: [{ name: '', value: '' }]
            }
            this.aiContractFieldsVisible = false
            this.aiContractFieldsReady = false
            this.aiContractFieldsContractType = ''
            this.aiContractFields = []
            this.aiContractFieldValues = {}
            this.aiGenerateKeywordVisible = false
            this.aiGenerateVisible = true
            this.fetchAiUserPoints()
        },

        async fetchAiUserPoints() {
            try {
                const res = await aiGetUserPointsnum()
                if (!res || res.code !== 200) return
                const data = res.data || {}
                const remaining = Number(data.remaining_points_num)
                const expected = Number(data.expected_consume_num)
                if (Number.isFinite(remaining)) this.aiCurrentPoints = remaining
                if (Number.isFinite(expected)) this.aiGenerateCostPoints = expected
            } catch (e) {
                console.error(e)
                this.$Message.error('获取积分失败')
            }
        },

        addPartyItem(side) {
            const key = side === 'a' ? 'party_a' : 'party_b'
            this.aiGenerateForm[key].push({ name: '', value: '' })
        },

        removePartyItem(side, index) {
            const key = side === 'a' ? 'party_a' : 'party_b'
            this.aiGenerateForm[key].splice(index, 1)
        },

        addTermItem() {
            this.aiGenerateForm.terms.push({ name: '', value: '' })
        },

        removeTermItem(index) {
            this.aiGenerateForm.terms.splice(index, 1)
        },

        goRecharge() {
            if (!this.$router) return
            localStorage.setItem('ai_generate_permissions_id',1006)
            this.$router.push('/application/center')
        },

        submitAiGenerate() {
            if (this.aiGenerateSubmitting) return
            this.$Modal.confirm({
                title: '确认生成并覆盖？',
                content: '生成后将覆盖当前编辑器中的合同内容。是否确认继续？',
                onOk: () => {
                    this.doSubmitAiGenerate()
                }
            })
        },

        async doSubmitAiGenerate() {
            if (this.aiGenerateSubmitting) return
            const { contract_type, keyword, party_a, party_b, terms } = this.aiGenerateForm || {}
            if (!contract_type) {
                this.$Message.warning('请填写合同类型')
                return
            }
            this.aiGenerateSubmitting = true
            const loadingMsg = this.$Message.loading({
                content: 'AI 正在生成合同，请稍候...',
                duration: 0
            })
            let aiLoadingClosed = false
            const closeAiLoading = () => {
                if (aiLoadingClosed) return
                aiLoadingClosed = true
                if (typeof loadingMsg === 'function') loadingMsg()
            }
            try {
                const keywordTrim = String(keyword || '').trim()
                const fields_data = this.buildAiFieldsDataForSubmit()
                const res = await aiGenerateContract({
                    contract_type,
                    ...(fields_data && Object.keys(fields_data).length ? { fields_data } : {}),
                    ...(keywordTrim ? { keyword: keywordTrim } : {}),
                    party_a,
                    party_b,
                    terms
                })
                if (!res || res.code !== 200 || !res.data) {
                    this.$Message.error((res && res.msg) || 'AI 合同生成失败')
                    return
                }
                const { contract_html, contract_text } = res.data || {}
                const html = contract_html || (contract_text ? `<pre>${this.escapeHtml(contract_text)}</pre>` : '')
                if (html) {
                    this.setHtml(html)
                    // 确保处于编辑模式
                    if (!this.isEditMode) this.switchToEditMode()
                    this.hasAiGeneratedContract = true
                }
                closeAiLoading()
                this.$Message.success(res.msg || '生成完成')
                this.aiGenerateVisible = false
                this.fetchAiUserPoints()
            } catch (e) {
                const msg = (e && (e.msg || e.message)) || 'AI 合同生成失败'
                this.$Message.error(msg)
            } finally {
                closeAiLoading()
                this.aiGenerateSubmitting = false
            }
        },

        async handleAiGenerateFieldsClick() {
            const ct = String((this.aiGenerateForm && this.aiGenerateForm.contract_type) || '').trim()
            if (!ct) {
                this.$Message.warning('请先填写合同类型')
                return
            }
            if (this.aiContractFieldsLoading) return

            // 合同类型变化时，清空旧表单
            if (this.aiContractFieldsContractType && this.aiContractFieldsContractType !== ct) {
                this.aiContractFields = []
                this.aiContractFieldValues = {}
            }
            this.aiContractFieldsVisible = true
            this.aiContractFieldsLoading = true
            const closeMsg = this.$Message.loading({
                content: '正在获取合同表单字段...',
                duration: 0
            })
            let closed = false
            const closeLoading = () => {
                if (closed) return
                closed = true
                if (typeof closeMsg === 'function') closeMsg()
            }

            try {
                const res = await aiGetContractFields({ contract_type: ct })
                const data = (res && res.data) || {}
                const fields = Array.isArray(data.fields) ? data.fields : []
                this.aiContractFieldsContractType = ct
                this.aiContractFields = fields
                this.aiContractFieldsReady = true

                const nextValues = { ...(this.aiContractFieldValues || {}) }
                fields.forEach(f => {
                    const label = f && f.label
                    if (!label) return
                    if (!(label in nextValues)) nextValues[label] = ''
                })
                this.aiContractFieldValues = nextValues
                this.$Message.success((res && res.msg) || '获取成功')
            } catch (e) {
                const msg = (e && (e.msg || e.message)) || '获取字段失败'
                this.$Message.error(msg)
            } finally {
                this.aiContractFieldsLoading = false
                closeLoading()
            }
        },

        buildAiFieldsDataForSubmit() {
            const ct = String((this.aiGenerateForm && this.aiGenerateForm.contract_type) || '').trim()
            if (!ct) return {}
            if (!this.aiContractFieldsVisible) return {}
            if (this.aiContractFieldsContractType && this.aiContractFieldsContractType !== ct) return {}

            const fields = Array.isArray(this.aiContractFields) ? this.aiContractFields : []
            const values = this.aiContractFieldValues || {}

            const toYMD = (d) => {
                if (!d) return ''
                // view-design DatePicker 可能返回 Date 或字符串
                if (Object.prototype.toString.call(d) === '[object Date]' && !isNaN(d.getTime())) {
                    const yyyy = d.getFullYear()
                    const mm = String(d.getMonth() + 1).padStart(2, '0')
                    const dd = String(d.getDate()).padStart(2, '0')
                    return `${yyyy}-${mm}-${dd}`
                }
                return String(d || '').trim()
            }

            const out = {}
            fields.forEach(f => {
                const label = f && f.label
                if (!label) return
                let v = values[label]
                if (f && f.type === 'date') v = toYMD(v)
                const vStr = String(v === undefined || v === null ? '' : v).trim()
                if (!vStr) return
                out[label] = vStr
            })
            return out
        },

        escapeHtml(str) {
            return String(str || '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;')
        },

        async handleSendChat() {
            const question = (this.chatInput || '').trim()
            if (!question || this.chatLoading) return

            this.chatMessages.push({
                role: 'user',
                content: question
            })
            this.chatInput = ''
            this.chatLoading = true
            // 确保「思考中...」占位已渲染后再滚到底部
            this.$nextTick(() => {
                this.scrollChatToBottom()
            })

            try {
                const res = await aiSendMultichat({
                    question,
                    model: this.chatModel,
                    conversation_id: this.chatConversationId || 0
                })
                if (res && res.data) {
                    const { answer, conversation_id } = res.data
                    if (conversation_id) {
                        this.chatConversationId = conversation_id
                    }
                    this.chatMessages.push({
                        role: 'assistant',
                        content: answer || ''
                    })
                    this.$nextTick(() => {
                        this.scrollChatToBottom()
                    })
                } else {
                    this.$Message.error('AI 对话失败')
                }
            } catch (e) {
                const msg = (e && e.msg) || (e && e.message) || 'AI 对话失败'
                // 也把错误信息以 AI 回复形式展示在对话里（尤其是后端 400 的 msg）
                this.chatLoading = false
                this.chatMessages.push({
                    role: 'assistant',
                    content: msg
                })
                this.$nextTick(() => {
                    this.scrollChatToBottom()
                })
                this.$Message.error(msg)
            } finally {
                this.chatLoading = false
                this.fetchAiUserPoints()
            }
        },

        scrollChatToBottom() {
            const container = this.$refs.chatScrollEl
            const bottom = this.$refs.chatBottomEl
            if (bottom && container && typeof bottom.scrollIntoView === 'function') {
                // 以对话底部锚点为准，适配高度计算不准的场景
                bottom.scrollIntoView({ behavior: 'auto', block: 'end' })
                return
            }
            if (container && container.scrollHeight) {
                container.scrollTop = container.scrollHeight
            }
        },

        appendReviewStreamChunk(chunkText, targetMsg) {
            if (!chunkText || !targetMsg) return
            targetMsg.content += chunkText
            this.$nextTick(() => {
                this.scrollReviewToBottom()
            })
        },

        scrollReviewToBottom() {
            const container = this.$refs.reviewScrollEl
            if (container && container.scrollHeight) {
                container.scrollTop = container.scrollHeight
            }
        },

        async streamReviewByFetch(payload, targetMsg) {
            let hasContent = false
            await flowRequest({
                url: '/ai/contract/stream_review',
                method: 'POST',
                data: payload,
                onMessage: (msg) => {
                    if (msg && typeof msg === 'object' && typeof msg.code !== 'undefined' && Number(msg.code) !== 200) {
                        throw new Error(msg.msg || '合同审查失败')
                    }
                    if (msg && typeof msg === 'object' && msg.type === 'content') {
                        this.appendReviewStreamChunk(msg.data || '', targetMsg)
                        hasContent = true
                        return
                    }
                    if (msg && typeof msg === 'object' && typeof msg.data === 'string') {
                        this.appendReviewStreamChunk(msg.data, targetMsg)
                        hasContent = true
                        return
                    }
                    if (typeof msg === 'string') {
                        this.appendReviewStreamChunk(msg, targetMsg)
                        hasContent = true
                    }
                },
                onChunk: (raw) => {
                    // 兼容后端非 SSE 直接返回 JSON：{"code":400,"msg":"..."}
                    const text = String(raw || '').trim()
                    if (!text || text.startsWith('data:')) return
                    let json = null
                    try {
                        json = JSON.parse(text)
                    } catch (e) {
                        // 非 JSON 文本，视为普通内容
                        return
                    }
                    if (json && typeof json.code !== 'undefined' && Number(json.code) !== 200) {
                        throw new Error(json.msg || '合同审查失败')
                    }
                }
            })
            return hasContent
        },

        async handleContractReview(mode = 'contract_text', type = 1) {
            if (this.reviewLoading) return
            const contractHtml = (this.getHtml && this.getHtml()) || ''
            if (!contractHtml || !contractHtml.trim()) {
                this.$Message.warning('请先在编辑器中填写合同内容')
                return
            }

            this.reviewLoading = true
            try {
                let payload = null
                if (mode === 'contract_file') {
                    const htmlBlob = new Blob([contractHtml], { type: 'text/html;charset=utf-8' })
                    const contractFile = new File([htmlBlob], 'contract.html', { type: 'text/html' })
                    payload = new FormData()
                    payload.append('contract_file', contractFile)
                    payload.append('model', 'qwen')
                    payload.append('type', String(type))
                } else {
                    payload = {
                        contract_text: contractHtml,
                        model: 'qwen',
                        type
                    }
                }
                const targetMsg = { role: 'ai', content: '' }
                this.reviewMessages.push(targetMsg)
                this.$nextTick(() => {
                    this.scrollReviewToBottom()
                })
                const hasContent = await this.streamReviewByFetch(payload, targetMsg)
                targetMsg.content = (targetMsg.content || '').trim()
                if (!hasContent && !targetMsg.content) {
                    targetMsg.content = '本次未返回详细审查结果。'
                }
                this.$nextTick(() => {
                    this.scrollReviewToBottom()
                })
            } catch (e) {
                const msg = (e && e.msg) || (e && e.message) || '合同审查失败'
                const last = this.reviewMessages[this.reviewMessages.length - 1]
                if (last && last.role === 'ai' && !last.content) {
                    last.role = 'error'
                    last.content = msg
                } else {
                    this.reviewMessages.push({
                        role: 'error',
                        content: msg
                    })
                }
                this.$nextTick(() => {
                    this.scrollReviewToBottom()
                })
                this.$Message.error(msg)
            } finally {
                this.reviewLoading = false
            }
        },

        printDocument() {
            const htmlContent = this.getHtml()
            const printWindow = window.open('', '_blank')
            const doc = printWindow.document
            doc.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <meta charset="utf-8">
                    <title>合同文档</title>
                    <style>
                        @page { size: A4; margin: 20mm; }
                        ${this.getContractDocumentCssForExport()}
                        @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
                    </style>
                </head>
                <body>${htmlContent}</body>
                </html>
            `)
            doc.close()
            printWindow.onload = () => {
                setTimeout(() => printWindow.print(), 250)
            }
        },

        buildPages() {
            const html = this.getHtml()
            if (!html || !html.trim()) {
                this.pages = []
                return
            }

            const tempDiv = document.createElement('div')
            tempDiv.style.width = `${this.pageWidth - this.pageMarginX * 2}px`
            tempDiv.style.padding = `${this.pageMarginTop}px ${this.pageMarginX}px ${this.pageMarginBottom}px ${this.pageMarginX}px`
            tempDiv.style.position = 'absolute'
            tempDiv.style.visibility = 'hidden'
            tempDiv.style.fontFamily = '"SimSun","宋体","NSimSun","新宋体",serif'
            tempDiv.style.fontSize = '16px'
            tempDiv.style.lineHeight = '1.75'
            tempDiv.style.color = '#000000'
            tempDiv.innerHTML = html
            document.body.appendChild(tempDiv)

            const children = Array.from(tempDiv.children)
            const maxPageHeight = this.contentHeight
            let currentHeight = 0
            let current = []
            const pages = []

            children.forEach(child => {
                const h = child.offsetHeight
                if (currentHeight + h > maxPageHeight && current.length) {
                    pages.push({ content: current.map(el => el.outerHTML).join('') })
                    current = [child]
                    currentHeight = h
                } else {
                    current.push(child)
                    currentHeight += h
                }
            })
            if (current.length) pages.push({ content: current.map(el => el.outerHTML).join('') })

            document.body.removeChild(tempDiv)
            this.pages = pages
        }
    }
}
</script>

<style scoped lang="scss">
.editor-page {
    position: relative;
    width: 100%;
    height: 100vh;
    max-height: 100vh;
    display: flex;
    flex-direction: column;
    background: #f3f4f6;
    overflow: hidden;
}

.page-header {
    min-height: 52px;
    height: auto;
    background: #fff;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    gap: 12px;
    padding: 16px 25px;
    border-bottom: 1px solid #e8eaec;
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.03);
    flex-shrink: 0;
    z-index: 99;
}

.header-actions {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    justify-self: start;
    min-width: 0;
}

.header-title-wrap {
    justify-self: center;
    position: relative;
}

.header-title-main {
    display: flex;
    align-items: center;
    justify-content: center;
}

.header-upload-tip {
    position: absolute;
    top: 50%;
    left: calc(100% + 12px);
    transform: translateY(-50%);
    color: #999;
    font-size: 12px;
    white-space: nowrap;
}

.header-back-wrap {
    justify-self: end;
    display: flex;
    // flex-direction: column;
    align-items: flex-end;
    gap: 6px;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
}

.header-back-btn {
    flex-shrink: 0;
    padding: 0 6px 0 2px !important;
    height: 28px !important;
    color: #515a6e !important;
}

.header-back-btn:hover {
    color: #4877e8 !important;
}

.header-title {
    font-size: 15px;
    font-weight: 600;
    color: #1b2742;
    letter-spacing: -0.01em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ai-generate-row {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}

.ai-generate-body {
    max-height: 500px;
    overflow-y: auto;
    padding-right: 6px;
}

.ai-point-tip {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px dashed #d7dce5;
    font-size: 14px;
    line-height: 1.5;
    color: #515a6e;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 3px;
    white-space: nowrap;
    overflow-x: auto;
    display: flex;
    justify-content: flex-end;
}

.ai-point-tip__num {
    // display: inline-block;
    // min-width: 22px;
    // text-align: center;
    // border: 1px solid #efca7a;
    // background: #fff4cf;
    // line-height: 1.25;
    // font-size: 12px;
    // color: #7a4d00;
    // border-radius: 2px;
    // padding: 1px 4px;
    // font-weight: 600;
    color: #2d8cf0;
    margin: 0 4px;
}

.ai-point-tip__gap {
    display: inline-block;
    width: 14px;
    flex-shrink: 0;
}

.ai-point-tip__recharge {
    color: #2d8cf0;
    margin-left: 12px;
    cursor: pointer;
    text-decoration: none;
    flex-shrink: 0;
}

.ai-point-tip__recharge:hover {
    color: #57a3f3;
}

.header-right {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
}

.header-upload-wrap {
    display: inline-block;
}

::v-deep .header-right .ivu-btn-small {
    padding: 0 12px;
    height: 28px;
    font-size: 12px;
}

::v-deep .ivu-tooltip-inner {
    background: #000 !important;
    background-color: #000 !important;
}

::v-deep .header-right .ivu-upload {
    display: inline-block;
}

.editor-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0;
    overflow: hidden;
}

.editor-entry-guide {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
}

.editor-entry-guide__card {
    width: 100%;
    max-width: 640px;
    background: #fff;
    border: 1px solid #e8eaec;
    border-radius: 10px;
    padding: 28px 24px;
    text-align: center;
    box-shadow: 0 6px 18px rgba(27, 39, 66, 0.08);
}

.editor-entry-guide__title {
    margin: 0;
    font-size: 18px;
    color: #17233d;
}

.editor-entry-guide__desc {
    margin: 10px 0 18px;
    font-size: 13px;
    color: #657180;
    line-height: 1.7;
}

.editor-mode {
    flex: 1;
    overflow: auto;
    padding: 0;
    background: #f3f4f6;
    border-radius: 0;
    margin-top: 0;
}

.ai-editor-host {
    width: 100%;
    height: auto;
    min-height: 1132px;
    box-sizing: border-box;
}

.aie-container {
    border: none !important;
}

.aie-header-panel {
    position: sticky;
    top: 0;
    z-index: 1;
    min-width: 800px;
}

/* 适配官网 Demo：让内置 header 内容居中 */
::v-deep .aie-header-panel aie-header > div {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0;
}

.aie-container-panel {
    width: calc(100% - 2rem - 2px);
    max-width: 800px;
    min-width: 800px;
    margin: 1rem auto;
    border: 1px solid rgb(229, 231, 235);
    background-color: #fff;
    height: 100%;
    min-height: 100vh;
    padding: 0;
    z-index: 99;
    box-sizing: border-box;
    border-radius: 8px;
}

.aie-header-panel aie-header > div {
    align-items: center;
    justify-content: center;
    padding: 10px 0;
}

.aie-main {
    position: relative;
}

.aie-directory {
    position: absolute;
    top: 24px;
    left: 12px;
    width: 252px;
    z-index: 0;
    background: #fff;
    border: 1px solid #e8eaec;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(27, 39, 66, 0.07);
    padding: 0 0 8px;
    box-sizing: border-box;
}

.aie-directory__head {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px 8px;
    margin: 0 8px 4px;
    border-bottom: 1px solid #f0f1f3bf;
}

.aie-directory__head-mark {
    width: 3px;
    height: 14px;
    border-radius: 2px;
    background: linear-gradient(180deg, #4877e8 0%, #6a9fff 100%);
    flex-shrink: 0;
}

.aie-directory h5 {
    margin: 0;
    color: #1b2742;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.3;
    letter-spacing: -0.02em;
}

.aie-outline-list {
    max-height: #{"min(58vh, 420px)"};
    overflow-x: hidden;
    overflow-y: auto;
    padding: 2px 8px 4px;
    -webkit-overflow-scrolling: touch;
}

.aie-outline-list::-webkit-scrollbar {
    width: 5px;
}

.aie-outline-list::-webkit-scrollbar-thumb {
    background: #dcdee2;
    border-radius: 3px;
}

.aie-directory a {
    min-height: 28px;
    font-size: 13px;
    color: #515a6e;
    line-height: 1.35;
    text-decoration: none;
    width: 100%;
    display: flex;
    align-items: center;
    margin: 0 0 2px;
    padding: 5px 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-radius: 6px;
    box-sizing: border-box;
    transition: background 0.15s ease, color 0.15s ease;
}

.aie-directory a:hover {
    cursor: pointer;
    background-color: #f4f6f9;
    color: #2d8cf0;
}

.aie-directory a.active {
    background-color: rgba(72, 119, 232, 0.14);
    color: #2d5bd6;
    font-weight: 500;
}

.aie-title1 {
    font-size: 13px;
    font-weight: 600;
    padding-left: 8px !important;
}

.aie-title2 {
    font-size: 12px;
    font-weight: 500;
    padding-left: 16px !important;
}

.aie-title3 {
    font-size: 12px;
    padding-left: 24px !important;
}

.aie-title4 {
    font-size: 12px;
    padding-left: 32px !important;
}

.aie-title5 {
    font-size: 12px;
    padding-left: 40px !important;
}

.aie-title6 {
    font-size: 12px;
    padding-left: 48px !important;
}

.aie-directory-content {
    position: sticky;
    top: 108px;
}

.outline-empty {
    min-height: 36px;
    font-size: 12px;
    color: #c5c8ce;
    line-height: 1.5;
    padding: 8px 8px 6px;
    text-align: center;
    border: 1px dashed #e8eaec;
    border-radius: 6px;
    margin: 4px 0 0;
    background: #fafbfc;
}

@media screen and (max-width: 1280px) {
    .aie-directory {
        display: none;
    }
}

@media screen and (max-width: 1400px) {
    .aie-directory {
        width: 208px;
    }
}

/* AiEditor 填充的主编辑区 — 版心变量（与 data 中 pageMargin*、pageWidth 保持一致） */
.aie-container-main {
    padding: 0;
    --contract-sheet-w: 800px;
    --contract-page-mt: 56px;
    --contract-page-mx: 72px;
    --contract-page-mb: 56px;
}

/*
 * 自定义布局下，真正可滚动的是 mainEl（.aie-container-main 的第一个子节点），
 * .aie-editor-content 在非自定义布局才出现；原先只写 .aie-editor-content 会导致页边距不生效。
 */
::v-deep .aie-container-main .aie-content,
::v-deep .aie-container-main .aie-editor,
::v-deep .aie-container-main .aie-editor-content {
    box-sizing: border-box;
}

::v-deep .aie-container-main > div:first-child,
::v-deep .aie-container-main .aie-editor-content {
    box-sizing: border-box;
    width: var(--contract-sheet-w);
    max-width: 100%;
    min-height: 1132px;
    margin: 0 auto;
    background: #fff;
    padding: var(--contract-page-mt) var(--contract-page-mx) var(--contract-page-mb) var(--contract-page-mx);
    border-radius: 2px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* 编辑区版式：贴近 Word/WPS 中文合同（宋体小四、行距、首行缩进、表格线框） */
::v-deep .aie-container-main .aie-content {
    font-family: 'SimSun', '宋体', 'NSimSun', '新宋体', serif;
    font-size: 16px;
    line-height: 1.75;
    color: #000000;
    text-align: justify;
    word-break: break-word;
    -webkit-font-smoothing: antialiased;
}

::v-deep .aie-container-main .aie-content p {
    margin: 0 0 8px 0;
    text-indent: 0em;
}

::v-deep .aie-container-main .aie-content p[style*='text-align:center'],
::v-deep .aie-container-main .aie-content p[style*='text-align: center'] {
    text-indent: 0;
}

::v-deep .aie-container-main .aie-content h1,
::v-deep .aie-container-main .aie-content h2,
::v-deep .aie-container-main .aie-content h3,
::v-deep .aie-container-main .aie-content h4,
::v-deep .aie-container-main .aie-content h5,
::v-deep .aie-container-main .aie-content h6 {
    text-indent: 0;
    font-family: 'SimHei', '黑体', 'Microsoft YaHei', '微软雅黑', sans-serif;
    color: #000000;
}

::v-deep .aie-container-main .aie-content h1 {
    font-size: 22pt;
    font-weight: bold;
    text-align: center;
    margin: 16px 0;
}

::v-deep .aie-container-main .aie-content h2 {
    font-size: 16pt;
    font-weight: bold;
    margin: 16px 0 8px 0;
}

::v-deep .aie-container-main .aie-content h3 {
    font-size: 15pt;
    font-weight: bold;
    margin: 12px 0 8px 0;
}

::v-deep .aie-container-main .aie-content h4 {
    font-size: 14pt;
    font-weight: bold;
    margin: 10px 0 6px 0;
}

::v-deep .aie-container-main .aie-content h5,
::v-deep .aie-container-main .aie-content h6 {
    font-size: 12pt;
    font-weight: bold;
    margin: 8px 0 6px 0;
}

::v-deep .aie-container-main .aie-content table {
    border-collapse: collapse;
    width: 100%;
    table-layout: fixed;
    margin: 8px 0;
}

::v-deep .aie-container-main .aie-content th,
::v-deep .aie-container-main .aie-content td {
    border: 1px solid #000000;
    padding: 4px 8px;
    vertical-align: top;
    font-size: 16px;
    line-height: 1.75;
}

::v-deep .aie-container-main .aie-content th {
    font-weight: bold;
    text-align: center;
    background: #f3f3f3;
}

::v-deep .aie-container-main .aie-content ul,
::v-deep .aie-container-main .aie-content ol {
    margin: 8px 0;
    padding-left: 2em;
    text-align: left;
}

::v-deep .aie-container-main .aie-content li {
    margin: 4px 0;
    text-indent: 0;
}

::v-deep .aie-container-main .aie-content blockquote {
    margin: 8px 0;
    padding: 4px 0 4px 12px;
    border-left: 3px solid #cccccc;
    color: #333333;
}

::v-deep .aie-container-main .aie-content img {
    max-width: 100%;
    height: auto;
    vertical-align: middle;
}

::v-deep .aie-container-main .aie-content u {
    text-underline-position: under;
}

.preview-mode {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
    background: #ebedf2;
    border-radius: 0;
    margin-top: 0;
}

.preview-toolbar {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    padding: 12px 20px;
    background: #fff;
    border-bottom: 1px solid #e8eaec;
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
    z-index: 5;
}

.preview-toolbar__left {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
}

.preview-toolbar__icon-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: linear-gradient(135deg, #eef3ff 0%, #e4ecff 100%);
    color: #4877e8;
    flex-shrink: 0;
}

.preview-toolbar__titles {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
}

.preview-toolbar__title {
    font-size: 16px;
    font-weight: 600;
    color: #1b2742;
    line-height: 1.3;
}

.preview-toolbar__hint {
    font-size: 12px;
    color: #808695;
    line-height: 1.4;
}

.preview-toolbar__right {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.preview-toolbar__zoom-label {
    font-size: 12px;
    color: #515a6e;
    margin-right: -4px;
}

.preview-zoom-btns {
    flex-shrink: 0;
}

.preview-toolbar__action {
    flex-shrink: 0;
}

.preview-scroll {
    flex: 1;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 24px 16px 32px;
    background: linear-gradient(180deg, #dfe3ea 0%, #e8ebf0 120px, #ebedf2 100%);
}

.preview-zoom-root {
    width: 100%;
    display: flex;
    justify-content: center;
}

.preview-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 320px;
    padding: 40px 16px;
}

.preview-empty__card {
    text-align: center;
    max-width: 400px;
    padding: 36px 32px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 28px rgba(27, 39, 66, 0.08);
    border: 1px solid #e8eaec;
    color: #808695;
}

.preview-empty__card .ivu-icon {
    color: #c5c8ce;
    margin-bottom: 16px;
}

.preview-empty__title {
    margin: 0 0 8px;
    font-size: 16px;
    font-weight: 600;
    color: #515a6e;
}

.preview-empty__desc {
    margin: 0 0 20px;
    font-size: 13px;
    line-height: 1.6;
    color: #808695;
}

.pages-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 28px;
    padding-bottom: 24px;
}

.page {
    width: 800px;
    min-height: 1132px;
    background: #fff;
    padding: 56px 72px 20px;
    box-shadow:
        0 1px 3px rgba(0, 0, 0, 0.06),
        0 12px 28px rgba(27, 39, 66, 0.1);
    position: relative;
    border-radius: 3px;
    box-sizing: border-box;
    border: 1px solid rgba(0, 0, 0, 0.06);
    display: flex;
    flex-direction: column;
}

.page-body {
    flex: 1 1 auto;
    min-height: 0;
}

.page-number {
    position: absolute;
    top: 15px;
    right: 20px;
    font-size: 11px;
    color: #999;
    font-family: Arial, sans-serif;
}

.page-sheet-footer {
    flex-shrink: 0;
    margin-top: auto;
    padding-top: 20px;
    text-align: center;
    font-size: 12px;
    color: #c5c8ce;
    letter-spacing: 0.02em;
    font-family: Arial, 'SimSun', sans-serif;
}

.page-content {
    font-family: 'SimSun', '宋体', 'NSimSun', '新宋体', serif;
    font-size: 16px;
    line-height: 1.75;
    color: #000000;
    text-align: justify;
    word-break: break-word;
}

/* v-html 注入内容需穿透 scoped */
::v-deep .page-content p {
    margin: 0 0 8px 0;
    text-indent: 0em;
}

::v-deep .page-content p[style*='text-align:center'],
::v-deep .page-content p[style*='text-align: center'] {
    text-indent: 0;
}

::v-deep .page-content h1,
::v-deep .page-content h2,
::v-deep .page-content h3,
::v-deep .page-content h4,
::v-deep .page-content h5,
::v-deep .page-content h6 {
    text-indent: 0;
    font-family: 'SimHei', '黑体', 'Microsoft YaHei', '微软雅黑', sans-serif;
    color: #000000;
}

::v-deep .page-content h1 {
    font-size: 22pt;
    font-weight: bold;
    text-align: center;
    margin: 16px 0;
}

::v-deep .page-content table {
    border-collapse: collapse;
    width: 100%;
    margin: 8px 0;
}

::v-deep .page-content th,
::v-deep .page-content td {
    border: 1px solid #000000;
    padding: 4px 8px;
    vertical-align: top;
}

::v-deep .page-content th {
    font-weight: bold;
    text-align: center;
    background: #f3f3f3;
}

.page-counter {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 16px 0;
}
.counter-content {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 6px 0;
    padding: 10px 24px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 24px;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    color: #fff;
    font-size: 14px;
    font-weight: 500;
}

.counter-content .ivu-icon {
    color: #fff;
    margin-right: 8px;
    font-size: 18px;
}

.divider {
    color: rgba(255, 255, 255, 0.5);
    margin: 0 10px;
    user-select: none;
}
.counter-text {
    color: #fff;
    margin: 0 6px;
}

.spark-version-hint {
    margin: -8px 0 0;
    padding: 0 0 0 118px;
    font-size: 12px;
    color: #808695;
    line-height: 1.55;
}

.spark-version-hint__title {
    margin: 0 0 6px;
    font-weight: 500;
    color: #515a6e;
}

.spark-version-hint__list {
    margin: 0;
    padding-left: 1.2em;
}

.spark-version-hint__list li {
    margin: 2px 0;
}
.r_back {
    .iconfont {
        font-size: 22px;
        cursor: pointer;

        &:hover {
            color: inherit;
        }
    }
}

.icon-action {
    position: relative;
    width: 34px;
    height: 34px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #515a6e;
    cursor: pointer;
    user-select: none;
}

.icon-action .iconfont {
    font-size: 22px !important;
}

.icon-action .iconfont-size-28 {
    font-size: 28px !important;
}

.icon-action:hover {
    background: rgba(27, 39, 66, 0.04);
}

.icon-action--theme {
    color: #2d8cf0;
}

.icon-action--theme:hover {
    background: rgba(45, 140, 240, 0.08);
}

.icon-action--disabled {
    opacity: 0.55;
    cursor: not-allowed;
    pointer-events: none;
}

.icon-action--loading {
    pointer-events: none;
}

.ai-fields-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px 12px;
}

.ai-field-item {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.ai-field-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.ai-field-row__label {
    width: 140px;
    flex: 0 0 140px;
    text-align: right;
    font-size: 12px;
    color: #515a6e;
    line-height: 1.2;
}

.ai-field-row__control {
    flex: 0 0 auto;
}

.ai-keyword-toggle {
    display: flex;
    align-items: center;
    min-height: 32px;
}

.ai-keyword-body {
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

.icon-action__label {
    /* 已切换为 Tooltip，这个类暂时保留但不再渲染 */
    display: none;
} 

/* ========= 右侧 AI Drawer 样式 ========= */
.ai-right-drawer {
    ::v-deep .ivu-drawer-body {
        padding: 0;
        background: #f6f7fb;
        height: 100vh;
        overflow: hidden;
        padding: 0;
    }

    ::v-deep .ivu-drawer-content-wrapper {
        background: transparent;
    }
}

.ai-right-panel {
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.ai-right-head {
    flex-shrink: 0;
    height: 45px;
    display: flex;
    align-items: stretch;
    background: #fff;
    border-bottom: 1px solid rgba(232, 234, 236, 0.9);
}

.ai-right-tabs {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: stretch;
}

.ai-right-close {
    flex-shrink: 0;
    width: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0;
    padding: 0;
    background: transparent;
    color: #999;
    cursor: pointer;
    outline: none;
}

.ai-right-close:hover {
    color: #515a6e;
    background: rgba(27, 39, 66, 0.04);
}

.ai-right-tab {
    flex: 1;
    appearance: none;
    border: 0;
    background: transparent;
    font-size: 14px;
    color: #515a6e;
    cursor: pointer;
    position: relative;
    outline: none;
}

.ai-right-tab.is-active {
    color: #2d8cf0;
    font-weight: 600;
}

.ai-right-tab.is-active::after {
    content: '';
    position: absolute;
    left: 18px;
    right: 18px;
    bottom: 0;
    height: 2px;
    background: #2d8cf0;
    border-radius: 2px;
}

.ai-right-body {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

.ai-chat-panel,
.ai-review-panel {
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.ai-chat-panel {
    background: #f6f7fb;
    min-height: 0;
}

.ai-chat-messages {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 16px 14px;
    scrollbar-gutter: stable;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    overscroll-behavior: contain;
}

.ai-chat-empty {
    padding: 28px 0;
    text-align: center;
    color: #808695;
    font-size: 13px;
    /* 空态时希望仍居中展示 */
    margin-top: auto;
    margin-bottom: auto;
}

.ai-chat-message {
    display: flex;
    margin: 0 0 12px;
}

.ai-chat-messages > .ai-chat-message:last-child {
    margin-bottom: 0;
}

.ai-chat-message__role {
    flex-shrink: 0;
    width: 32px;
    font-size: 11px;
    color: #8a94a6;
    text-align: center;
    margin-top: 6px;
}

.ai-chat-message__content {
    flex: 1;
    min-width: 0;
    min-height: 0;
}

.ai-chat-message__content pre {
    margin: 0;
    white-space: pre-wrap;
    word-break: break-word;
    font-family: inherit;
    font-size: 13px;
    line-height: 1.65;
    overflow-wrap: anywhere;
}

.ai-chat-message--user {
    justify-content: flex-end;
}

.ai-chat-message--user .ai-chat-message__role {
    order: 2;
}

.ai-chat-message--user .ai-chat-message__content {
    display: flex;
    justify-content: flex-end;
}

.ai-chat-message--user .ai-chat-message__content pre {
    background: #2d8cf0;
    color: #fff;
    padding: 10px 12px;
    border-radius: 12px;
    max-width: 88%;
    box-shadow: 0 6px 18px rgba(45, 140, 240, 0.18);
}

.ai-chat-message--ai .ai-chat-message__content pre {
    background: #ffffff;
    color: #1b2742;
    padding: 10px 12px;
    border-radius: 12px;
    max-width: 88%;
    border: 1px solid rgba(27, 39, 66, 0.06);
}

.ai-chat-input {
    flex-shrink: 0;
    height: 140px;
    min-height: 140px;
    display: flex;
    flex-direction: column;
    padding: 12px 14px;
    border-top: 1px solid rgba(232, 234, 236, 0.9);
    background: #fff;
    overflow: hidden; /* 防止 textarea 默认最小高度把布局撑开 */
}

.ai-chat-input ::v-deep .ivu-input-wrapper {
    flex: 1;
    min-height: 0;
    height: 100%;
}

.ai-chat-input ::v-deep textarea {
    height: 100% !important;
    resize: none;
    overflow-y: auto;
}

.ai-chat-input__actions {
    margin-top: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    flex-shrink: 0;
}

.ai-chat-input__hint {
    font-size: 12px;
    color: #808695;
}

.ai-chat-input__hint-num {
    color: #2d8cf0;
    font-weight: 600;
}

.ai-chat-message--thinking .ai-chat-message__content pre {
    /* 思考中气泡略微强调，提升“正在处理”的感知 */
    animation: aiChatThinkingPulse 1.2s ease-in-out infinite;
}

.ai-chat-thinking {
    display: block;
}

.ai-chat-dots {
    display: inline-flex;
    align-items: center;
    margin-left: 6px;
    transform: translateY(-1px);
}

.ai-chat-dot {
    width: 4px;
    height: 4px;
    margin: 0 2px;
    background: rgba(27, 39, 66, 0.55);
    border-radius: 50%;
    opacity: 0.25;
    animation: aiChatDotBlink 1.2s infinite;
}

.ai-chat-dot:nth-child(1) {
    animation-delay: 0s;
}

.ai-chat-dot:nth-child(2) {
    animation-delay: 0.15s;
}

.ai-chat-dot:nth-child(3) {
    animation-delay: 0.3s;
}

@keyframes aiChatDotBlink {
    0% {
        opacity: 0.25;
        transform: translateY(0);
    }
    30% {
        opacity: 1;
        transform: translateY(-2px);
    }
    60% {
        opacity: 0.25;
        transform: translateY(0);
    }
    100% {
        opacity: 0.25;
        transform: translateY(0);
    }
}

@keyframes aiChatThinkingPulse {
    0% {
        box-shadow: 0 0 0 rgba(45, 140, 240, 0);
    }
    50% {
        box-shadow: 0 8px 22px rgba(45, 140, 240, 0.12);
    }
    100% {
        box-shadow: 0 0 0 rgba(45, 140, 240, 0);
    }
}

.ai-review-toolbar {
    padding: 14px 16px 10px;
    background: #fff;
    border-bottom: 1px solid rgba(232, 234, 236, 0.9);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    flex-shrink: 0; /* 保证工具栏始终在顶部 */
}

.ai-review-toolbar__buttons {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
}

.ai-review-toolbar__hint {
    font-size: 12px;
    color: #808695;
    line-height: 1.5;
}

.ai-review-content {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 16px 16px 24px;
}

.ai-review-messages {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.ai-review-messages .ai-chat-message {
    margin: 0;
}

.ai-review-messages .ai-chat-message__content pre {
    max-width: 100%;
}

.ai-review-message--error .ai-chat-message__role {
    color: #d93026;
}

.ai-review-message--error .ai-chat-message__content pre {
    background: #fff7f7;
    color: #d93026;
    padding: 10px 12px;
    border-radius: 12px;
    max-width: 100%;
    border: 1px solid rgba(217, 48, 38, 0.25);
}

.ai-review-btn {
    height: 32px;
    border-radius: 6px !important;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ai-review-btn .ivu-icon {
    margin-right: 6px;
}

.ai-review-btn--primary {
    box-shadow: 0 4px 10px rgba(45, 140, 240, 0.25);
}

.ai-review-btn--secondary {
    background: #f7f9fc;
    border-color: #d7dbe7;
    color: #515a6e;
}

.ai-review-btn--secondary:hover {
    background: #eef2fb;
    border-color: #c5cae6;
    color: #2d8cf0;
}

.ai-review-empty {
    padding: 28px 0;
    text-align: center;
    color: #808695;
    font-size: 13px;
}

.ai-review-section {
    margin-bottom: 14px;
    background: #fff;
    border: 1px solid rgba(232, 234, 236, 0.95);
    border-radius: 12px;
    padding: 14px 14px;
}

.ai-review-section__title {
    margin: 0 0 10px;
    font-size: 14px;
    font-weight: 600;
    color: #1b2742;
}

.ai-review-section__body {
    margin: 0;
    white-space: pre-wrap;
    word-break: break-word;
    font-family: inherit;
    font-size: 13px;
    line-height: 1.7;
}

.ai-review-list {
    margin: 0;
    padding: 0;
}

.ai-review-list li {
    list-style: none;
    padding: 8px 0;
    border-bottom: 1px dashed rgba(232, 234, 236, 0.9);
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

.ai-review-list li:last-child {
    border-bottom: none;
}

.ai-review-risk-level {
    flex-shrink: 0;
    font-size: 12px;
    color: #2d8cf0;
    background: rgba(45, 140, 240, 0.08);
    border: 1px solid rgba(45, 140, 240, 0.22);
    border-radius: 999px;
    padding: 2px 10px;
    line-height: 1.4;
}

.ai-review-risk-desc {
    font-size: 13px;
    color: #1b2742;
    line-height: 1.65;
}

/* 保险：避免全局样式影响 pre 的断行 */
::v-deep pre {
    white-space: pre-wrap;
    word-break: break-word;
}

</style>
 



